{
  "AlertsScreens": {
    "alertsTemplates": "Настройки алертов",
    "changeExecutor": "Сменить исполнителя",
    "changeStatus": "Изменить статус",
    "errors": {
      "failedLoadAlertDetails": "Не удалось загрузить подробную информацию об алерте",
      "failedLoadAlertsList": "Не удалось загрузить список алертов",
      "fieldNotEmptyAndMin3": "Это поле не должно быть пустым и содержать менее трех символов",
      "displayScheduleErrorMsg": "Некорректный синтаксис Cron выражения",
      "invalidInitialSchedule": "Неверный синтаксис исходного расписания Cron",
      "invalidSchedule": "Ошибка в Cron расписании"
    },
    "excludeFromReport": "Исключить из отчета",
    "excludeReason": "Причина исключения",
    "excludedFromReport": "Запись исключена из отчета",
    "executionHistory": "Журнал исполнения алерта",
    "manualStart": " Ручной запуск",
    "returnToReport": "Вернуть в отчет",
    "runNow": "Выполнить сейчас",
    "scheduledStart": "Запланированный старт",
    "showDetailedInfo": "Показать подробную информацию",
    "extendedInfo": {
      "blockedCashBoxesCount": "Количество заблокированных касс",
      "cashBoxesCount": "Количество касс",
      "punchedDocuments": "Количество пробитых чеков",
      "vatSum": "Сумма налога",
      "vatPercent": "Налоговая ставка",
      "documentSum": "Сумма чека",
      "documentGlobalNumber": "Номер кассового чека",
      "gapSize": "Количество потерянных кассовых чеков (разрыв)",
      "finalDocumentId": "Конечный фискальный ИД",
      "finalDocumentSum": "Конечная сумма чека",
      "initialDocumentId": "Начальный фискальный ИД",
      "initialDocumentSum": "Начальная сумма чека",
      "finalDocumentGlobalNumber": "Конечный номер кассового чека",
      "initialDocumentGlobalNumber": "Начальный номер кассового чека",
      "status": "Статус",
      "details": "Детали",
      "createdAtUtc": "Дата создания",
      "cashBoxRegDateAtUtc": "Дата регистрации кассы",
      "companyName": "Наименование налогоплательщика",
      "insertedAtUtc": "Дата получения кассового чека",
      "cashBoxTaxNumber": "Регистрационный номер кассы",
      "companyTaxNumber": "ИНН",
      "sum": "Сумма",
      "referencedDocId": "Чек аннулирования/Чек возврата",
      "certificateEndDateAtUtc": "Дата истечения сертификата",
      "timeDelta": "Отклонение времени (сек)",
      "lastOnlineAtUtc": "Была онлайн",
      "lastDocCreatedAtUtc": "Дата создания последнего чека",
      "lastDocInsertedAtUtc": "Дата получения последнего чека",
      "invalidGpsCashBox": "Неверные/отсутствующие GPS координаты по кассе",
      "invalidGpsCashBoxCreatedAtUtc": "Первоначальная дата определния неверных/отсутсвующих GPS координат",
      "invalidGpsStore": "Неверные/отсутствующие координаты по объекту",
      "storeTotal": "Количество объектов",
      "daysBetweenLastDocumentCreated": "Время, прошедшее с даты получения последнего кассового чека (число дней)",
      "cashBoxOfflineDate": "Дата перехода кассы в офлайн",
      "daysBetweenOffline": "Период в офлайне (дни)",
      "cashBoxStatus": "Статус кассы"
    },
    "rules": {
      "title": "Настройка правил алерта",
      "addRule": "Добавить правило",
      "id": "ID",
      "ruleType": "Тип правила",
      "taxNumber": "Уникальный идентификатор",
      "ruleEntityType": "Тип объекта правила",
      "insertedAtUtc": "Дата создания",
      "searchFieldHint": "Поиск по уникальному идентификатору",
      "editRule": "Изменить правило",
      "deleteRuleModalTitle": "Вы действительно хотите удалить это правило?",
      "deleteRulesModalTitle": "Вы действительно хотите удалить выбранные правила?",
      "ids": "IDs",
      "errors": {
        "rulesListNotFound": "Список правил не найден",
        "addRuleError": "Не удалось добавить правило",
        "editRuleError": "Не удалось отредактировать правило",
        "deleteRulesError": "Не удалось удалить правила",
        "failedDownloadRulesList": "Не удалось загрузить список правил",
        "failedLoadTaxNumbersList": "Не удалось загрузить список уникальных идентификаторов",
        "failedDownloadRuleTemplate": "Не удалось загрузить шаблон файла"
      },
      "loadRulesViaExcel": "Загрузить правила через excel",
      "getRulesTemplate": "Загрузить шаблон файла",
      "invalidFile": "Файл не соответствует шаблону",
      "deleteAllRules": "Удалить старые правила перед загрузкой новых",
      "dropZoneFileText": "Перетяните excel файл сюда или нажмите, чтобы выбрать"
    },
    "editSchedule": "Редактировать расписание алерта"
  },
  "AuthScreen": {
    "backToLoginForm": "Вернуться к форме для входа",
    "errors": {
      "loginError": "Ошибка входа: {{errorText}}",
      "invalidPhoneNumber": "Некорректный номер телефона",
      "noAccessibleSections": "Для вашей учетной записи нет доступных разделов",
      "operatorsNotFound": "Операторы не найдены",
      "requiredField": "Заполните это поле",
      "requiredFieldsNotFilled": "Не заполнены необходимые поля",
      "wrongEmailOrPassword": "Неверный логин или пароль",
      "rejectedByRecaptcha": "Доступ запрещен. Ваши действия расценены как подозрительные сервисом reCAPTCHA, попробуйте авторизоваться позже. (Статус SUSPICIOUS будет снят через {{leftTime}} мин) "
    },
    "login": "Войти",
    "logout": "Выйти",
    "sendCode": "Отправить запрос",
    "rememberMe": "Запомнить меня",
    "serviceProvider": "Поставщик услуг",
    "waitingForCustomerConfirmation": "Примите, пожалуйста, отправленный запрос. Проверьте идентичность кода запроса с приведенным ниже кодом."
  },
  "DashboardScreens": {
    "cashboxesByOperators": "Кассы по операторам",
    "coverage": "Охват",
    "documentsCounter": "Счетчик кассовых чеков",
    "documentsCounts": {
      "avg": "Среднее",
      "max": "Максимум",
      "min": "Минимум"
    },
    "errors": {
      "failedLoadDocsCountsStat": "Не удалось загрузить статистику по счетчикам кассовых чеков",
      "failedLoadDocsStat": "Не удалось загрузить статистику по кассовым чекам",
      "failedToLoadCashboxStat": "Не удалось загрузить статистику по кассам",
      "failedToLoadDevicesCountsStat": "Не удалось загрузить статистику количества токенов",
      "failedToLoadOperatorCashBoxesStat": "Не удалось загрузить статистику по кассам операторов",
      "failedToLoadPaymentTypesStat": "Не удалось загрузить статистику по видам оплаты",
      "failedToLoadRegistryItemsStat": "Не удалось загрузить статистику по элементам реестра",
      "failedToLoadTurnoversByActivity": "Не удалось загрузить статистику оборотов по видам деятельности"
    },
    "top": "Топ {{limit}}"
  },
  "MainScreen": {
    "downloadInPDF": "Загрузить как PDF",
    "downloadAsJPG": "Скачать чек",
    "errors": {
      "documentDuplicate": "Пожалуйста, введите регистрационный номер кассы для \"{{documentId}}\"",
      "documentForCashboxNotFound": "Кассовый чек \"{{documentId}}\" для кассы \"{{taxNumber}}\" не найден.",
      "documentNotFound": "Кассовый чек не найден.",
      "documentNotFoundText": "Если электронная форма кассового чека не найдена в течение 7 дней со дня ее создания, обратитесь в электронной форме в Государственную Налоговою Службу и приложите копию соответствующего кассового чека.",
      "invalidDocumentId": "Неверный идентификатор кассового чека",
      "serverError": "Кассовый чек не найден из-за ошибки сервера",
      "forbidden": "Доступ запрещен"
    },
    "linkToParentReceipt": "Ссылка на связанный чек",
    "linksToParentsReceipts": "Ссылки на связанные чеки",
    "searchDocumentByIdPlaceholder": "Фискальный ИД",
    "searchDocumentByTaxNumberPlaceholder": "Регистрационный номер кассы",
    "watermarkTestWarning": "Только для тестирования! Данный чек не подтверждает покупку!",
    "watermarkTestHint": "Если вы получили этот чек за покупку, обратитесь в Государственную налоговую службу."
  },
  "MapScreen": {
    "clearFilter": "Очистить фильтр",
    "lat": "Широта",
    "lng": "Долгота",
    "geographiCoordinates": "Географические координаты",
    "coordinates": "Координаты",
    "onlyPortableCashboxesAreShown": "Обратите внимание, что отображаются только портативные кассы"
  },
  "RegistryScreens": {
    "byCashboxes": "По кассам",
    "byObjects": "По объектам",
    "byPeriods": "По периодам",
    "cashBoxAlertsHistory": "История алертов кассы",
    "cashBoxAuditHistory": "Инфомация по техническим аудитам кассы",
    "cashBoxStateHistory": "История изменений режима кассы",
    "cashBoxStatusHistory": "История изменений статуса кассы",
    "cashBoxReplacementHistory": "Информация об установке временных касс",
    "cashBoxTimeHistory": "История корректности кассового времени",
    "cashBoxesRangeSelectHint": "Кроме касс снятых с регистрации",
    "cashBoxesTotal": "Кассы (всего)",
    "completeAttestation": "Завершить аттестацию",
    "countOfCashRegisters": "Количество кассовых аппаратов",
    "countOfCashboxes": "Количество касс",
    "countOfObjects": "Количество объектов",
    "devicesInStock": "Токены (на складе)",
    "documentation": "Документация",
    "errors": {
      "cashBoxesRequestFailed": "Запрос списка касс не выполнен",
      "cashBoxesStatsNotFound": "Не удалось получить статистику по кассам",
      "cashRegisterModelNotFound": "Модель кассового аппарата \"{{searchText}}\" не найдена",
      "cashRegistersModelsListReqFailed": "Запрос списка моделей кассовых аппаратов не выполнен",
      "cashboxNotFound": "Касса \"{{searchText}}\" не найдена",
      "cashboxesListNotFound": "Кассы не найдены!",
      "companiesListNotFound": "Налогоплательщики не найдены",
      "companyNotFound": "Налогоплательщик \"{{searchText}}\" не найден",
      "documentsNotFound": "Кассовые чеки не найдены",
      "documentsRequestFailed": "Запрос кассовых чеков не выполнен",
      "failedLoadFactoryNumbers": "Не удалось загрузить список кассовых аппаратов",
      "fieldNotEmpty": "Это поле не должно быть пустым",
      "operatorDataNotFound": "Данные об операторе не найдены",
      "operatorNotFound": "Оператор \"{{searchText}}\" не найден",
      "operatorsListNotFound": "Не удалось загрузить список операторов",
      "storeWithTaxNumberNotFound": "Объект \"{{searchText}}\" не найден",
      "storesListNotFound": "Объекты не найдены",
      "storesRequestFailed": "Запрос объектов не выполнен",
      "turnoversRequestFailed": "Запрос информации по оборотам не выполнен",
      "enterIntegerValue": "Введите целое значение от 1 до 100",
      "maxDatesRange": "Максимальный диапазон дат составляет 3 года ",
      "documentsExtendedDataNotFound": "Запрос расширенных данных для списка чеков не выполнен",
      "devicesListNotFound": "Не удалось загрузить список токенов",
      "deviceNotFound": "Токен \"{{searchText}}\" не найден",
      "cahboxNotRegistered": "Касса не зарегистрирована",
      "emptyLatitude": "Широта не может быть пустой строкой",
      "emptyLongitude": "Долгота не может быть пустой строкой",
      "updateStoreInfoFailed": "Не удалось обновить данные объекта",
      "latitudeOutOfBounds": "Введите значение широты от {{min}} до {{max}}",
      "longitudeOutOfBounds": "Введите значение долготы от {{min}} до {{max}}",
      "fileToBig": "Файл слишком большой",
      "fileToSmall": "Файл слишком мал",
      "storeOutOfAzBounds": "Объект находится вне необходимого региона",
      "allowableLongitudeRange": "Допустимый диапазон долготы: {{min}} - {{max}}",
      "allowableLatitudeRange": "Допустимый диапазон широты: {{min}} - {{max}}",
      "updateInOffline": "Обновление возможно только в режиме Онлайн",
      "firmwareUpdateNoSuitableVersions": "Нет списка подходящих для обновления версий",
      "waitingForSuitableVersionsList": "Получение списка подходящих для обновления версий...",
      "getSuitableTargetVersionsFailed": "Не удалось получить список подходящих для обновления версий прошивки",
      "firmwareUpdateNotNeeded": "Текущая версия актуальна. В обновлении нет необходимости",
      "firmwareUpdateForOldVersion": "Обновление возможно только для версий прошивки, начиная с {{version}}",
      "cashboxOutOfAzBounds": "Касса находится вне необходимого региона",
      "cashboxLocationDataNotFound": "Данные о местоположении кассы не найдены",
      "versionError": "Наименование версии должно быть от 1 до {{maxLength}} символов. Пожалуйста, используйте только цифры и следующий набор знаков: v  .  -",
      "emptyAttestationResult": "Пожалуйста, выберите результат аттестации",
      "cashRegisterModelVersionsNotFound": "Не удалось получить список версий ПО данной модели кассового аппарата",
      "cashRegisterModelVersionCheckSumsNotFound": "Не удалось получить список контрольных сумм для версии ПО {{versionName}}",
      "cashRegisterModelDocumentsNotFound": "Не удалось получить список документов данной модели кассового аппарата",
      "waitingForSoftwareVersions": "Получение списка версий ПО...",
      "emptySoftwareVersionsList": "Список версий ПО данной модели пуст",
      "cashRegisterCategoryNotSet": "Для управления процессом аттестации, пожалуйста, установите категорию кассового аппарата",
      "updateModelFailed": "Не удалось обновить данные модели кассового аппарата",
      "getStorePhotosFailed": "Не удалось получить список фотографий объекта",
      "getCashboxLocationsHistoryFailed": "Не удалось получить данные об истории изменения координат кассы",
      "getCashboxTrackingDataFailed": "Не удалось получить данные для отслеживания изменения координат кассы",
      "failedToGetDocument": "Не удалось получить данные о кассовом чеке",
      "requestToUpdateDeviceCertificateFailed": "Не удалось выполнить запрос на обновление сертификата токена",
      "certUpdateAlreadyInProgress": "Запрос не выполнен. Предыдущая задача обновить сертификат токена находится в процессе выполнения",
      "requestToCreateCashBoxLogsFailed": "Не удалось выполнить запрос на получение логов кассы",
      "cashBoxLogsRequestAlreadyInProgress": "Запрос не выполнен. Предыдущая задача получить логи кассы находится в процессе выполнения",
      "firmwareUpdateAlreadyInProgress": "Запрос не выполнен. Предыдущая задача обновить прошивку токена находится в процессе выполнения",
      "requestToUpdateDeviceFirmwareFailed": "Не удалось выполнить запрос на обновление прошивки токена",
      "envInfoRequestAlreadyInProgress": "Запрос не выполнен. Предыдущая задача получить системную информацию находится в процессе выполнения",
      "requestToGetEnvInfoFailed": "Не удалось выполнить запрос о системной информации кассы",
      "requestInOffline": "Запрос возможен только в режиме Онлайн",
      "blockCashBoxFailed": "Запрос заблокировать кассу не выполнен",
      "unblockCashBoxFailed": "Запрос разблокировать кассу не выполнен",
      "removeBlockUnblockScheduleFailed": "Не удалось удалить расписание",
      "singleDateValidationHint": "Выбранное время должно быть больше текущего",
      "datesPeriodValidationHint": "Верхняя граница периода должна быть больше нижней",
      "changeCashBoxStatusFailed": "Запрос изменить статус кассы не выполнен",
      "fiscalDriverOperationForOldVersion": "Операция возможна только для версии фискального драйвера, начиная с {{version}}",
      "taxpayerDataNotFound": "Данные о налогоплательщике не найдены",
      "cashRegistersListReqFailed": "Запрос списка кассовых аппаратов не выполнен",
      "cashRegisterNotFound": "Кассовый аппарат \"{{searchText}}\" не найден",
      "createInitOtpFailed": "Ошибка создания одноразового кода"
    },
    "logsList": "Логи кассы",
    "modelStatusHistory": "История изменений статуса модели",
    "receiptAmountRangeSelectHint": "Кроме чеков открытия и закрытия смены",
    "requestLogs": "Запросить логи",
    "startAttestation": "Начать аттестацию",
    "storesRangeSelectHint": "Только активные объекты",
    "turnoverForEntirePeriod": "Обороты за весь период",
    "timeRange": "Дата чека",
    "timeRangeTypes": {
      "QUICK_SELECT": "БЫСТРЫЙ ВЫБОР",
      "SHOW_DATES": "ДИАПАЗОН ДАТ",
      "COMMONLY_USED": "ЧАСТО ИСПОЛЬЗУЕМЫЕ"
    },
    "hideFiltersPanel": "Скрыть панель фильтров",
    "confirmIgnoreFilters": "Фильтры изменены, но не применены. Они будут сброшены к предыдущему состоянию.",
    "donorHint": "Сломанная касса, на замену которой была зарегистрирована текущая касса",
    "replacementsHint": "Кассы зарегистрированные на замену текущей кассы",
    "deviceStatusHistory": "История изменений статуса токена",
    "deviceFirmwareHistory": "История изменений прошивок токена",
    "deviceRegisteredCashbox": "Информация о зарегистрированной кассе",
    "deviceOperatorHistory": "История смены операторов",
    "deviceRegistrationHistory": "История регистраций токена в кассах",
    "coordinatesHistory": "История изменения координат",
    "cashBoxesList": "Список касс",
    "cashBoxStatistics": "Статистика по кассам",
    "latitudeLongitude": "Широта / Долгота",
    "doubleClickToSetCoordinates": "Щелкните дважды, чтобы установить координаты на карте",
    "modalMapDialogTitle": "Пожалуйста, укажите местоположение объекта на карте двойным щелчком",
    "initialCoordinates": "Начальные координаты",
    "selectedCoordinates": "Выбранные координаты",
    "deviceFirmwareUpdatesHistory": "История обновлений прошивок токена",
    "selectSuitableTargetVersion": "Выберите целевую версию прошивки из списка подходящих",
    "currentCashboxLocation": "Текущее местоположение кассы",
    "currentStoreLocation": "Местоположение объекта",
    "selectedHistoryLocation": "Выбранное в истории местоположение кассы",
    "viewControl": "Управление просмотром",
    "historyLocation": "Местоположение в истории",
    "countOfCashboxesByMode": "Количество касс по режиму работы",
    "countOfCashboxesByStatus": "Количество касс по статусу",
    "countOfCashboxesByType": "Количество касс по типу",
    "countOfObjectsByStatus": "Количество объектов по статусу",
    "startReattestation": "Начать повторную аттестацию",
    "completeReattestation": "Завершить повторную аттестацию",
    "eliminateCashRegisterModel": "Исключить модель",
    "activateCashRegisterModel": "Активизировать модель",
    "attestationCompleted": "Аттестация завершена",
    "attestationNotCompleted": "Аттестация не завершена. {{reason}}",
    "softwareVersionsHistory": "Версии программного обеспечения модели",
    "markVersionAsOutdated": "Пометить версию как устаревшую",
    "activateVersion": "Активизировать версию",
    "copyCheckSum": "Скопировать контрольную сумму версии",
    "confirmActivateCashRegisterModel": "Вы действительно хотите активизировать данную модель кассового аппарата?",
    "confirmEliminateCashRegisterModel": "Вы действительно хотите исключить данную модель кассового аппарата?",
    "confirmMarkVersionOutdated": "Вы действительно хотите пометить данную версию ПО как устаревшую?",
    "confirmActivateVersion": "Вы действительно хотите активизировать данную версию ПО?",
    "markOutdated": "Пометить как устаревшую",
    "selectSoftwareVersionForDocuments": "Выберите версию ПО, если документы связаны с одной из них",
    "checkSumHistory": "История изменения контрольных сумм",
    "noDataForCheckSumHistory": "Нет данных об истории изменений контрольных сумм",
    "noDataForLocationsHistory": "Нет данных для отображения истории изменения координат",
    "noDataForTrackingHistory": "Нет данных для отслеживания изменения координат кассы",
    "viewPictureDocument": "Просмотреть изображение чека",
    "documentImage": "Изображение чека",
    "documentDetails": "Подробная информация о чеке",
    "relatedDocuments": "Связанные чеки",
    "documentIdentification": "Идентификация чека",
    "incorrectDocumentDateHint": "Некорректная дата формирования чека",
    "technicalTasks": "Сервис и технические характеристики",
    "deviceCertUpdatesHistory": "История обновлений сертификата токена",
    "certificateUpdate": "Обновление сертификата токена",
    "requestsHistory": "История запросов",
    "updateCertificate": "Обновить сертификат",
    "refreshHistory": "Перезагрузить историю",
    "certUpdateRequestCreated": "Запрос обновить сертификат токена создан",
    "logsRequestCreated": "Запрос получить логи кассы создан",
    "cashBoxLogsHistory": "История запросов логов кассы",
    "firmwareUpdateRequestCreated": "Запрос обновить прошивку токена создан",
    "updateFirmware": "Обновить прошивку",
    "firmwareUpdate": "Обновление прошивки токена",
    "envInfoRequestCreated": "Запрос получить системную информацию создан",
    "envInfoHistory": "История запросов системной информации",
    "requestEnvInfo": "Запросить информацию",
    "envInfoList": "Системная информация",
    "modelsListLimitationByOperatorHint": "Опции данного фильтра лимитируются, если выбраны наименования операторов",
    "softwareVersionsLimitationByModelsHint": "Опции данного фильтра зависят от выбранной модели кассового аппарата",
    "cashRegisterModelStatistics": "Статистика по моделям кассовых аппаратов",
    "generalStatistics": "Общая статистика",
    "cashRegisterStatusHistory": "История изменений статуса кассового аппарата"
  },
  "ReportsScreen": {
    "errors": {
      "failedLoadReportsList": "Не удалось загрузить список отчетов"
    },
    "reportPeriod": "Период отчета",
    "reportDate": "Дата отчета",
    "searchFilterItems": {
      "cashBoxTaxNumbers": "Регистрационный номер кассы",
      "companyTaxNumbers": "ИНН",
      "operatorTaxNumbers": "ИНН оператора",
      "storeTaxNumbers": "Код объекта"
    },
    "turnovers": {
      "correctionsCount": "Коррекция: количество",
      "correctionsSum": "Коррекция: сумма",
      "moneybacksCount": "Возврат: количество",
      "moneybacksSum": "Возврат: сумма",
      "rollbacksCount": "Аннулирование: количество",
      "rollbacksSum": "Аннулирование: сумма",
      "salesCount": "Продажа: количество",
      "salesSum": "Продажа: сумма"
    },
    "timeIsIgnored": "В отчете по дням время в данном фильтре игнорируется",
    "byDay": "Отчет с агрегацией по дням",
    "byDayHint": "Отчёт будет загружен с агрегацией по дням"
  },
  "StatisticsScreen": {
    "goToCashboxesList": "Перейти к списку касс"
  },
  "SystemScreens": {
    "addUser": "Добавить пользователя",
    "adminPanel": "Панель администратора",
    "backToMonitoring": "Вернуться к мониторингу",
    "basicInfo": "Основная информация",
    "changePassword": "Изменить пароль",
    "confirmBlockUser": "Вы действительно хотите заблокировать пользователя?",
    "confirmDeleteUser": "Вы действительно хотите удалить пользователя?",
    "confirmUnblockUser": "Вы действительно хотите разблокировать пользователя?",
    "contactInfo": "Контактная информация",
    "copyPassword": "Скопировать пароль",
    "currentPasswordNotShown": "Текущий пароль пользователя не отображается",
    "editEmail": "Изменить адрес эл.почты",
    "editFirstName": "Изменить имя",
    "editLastName": "Изменить фамилию",
    "editMiddleName": "Изменить отчество",
    "editPhone": "Изменить номер телефона",
    "editUser": "Редактировать данные пользователя",
    "errors": {
      "addUserFailed": "Не удалось добавить пользователя",
      "blockUserFailed": "Не удалось заблокировать пользователя \"{{searchText}}\"",
      "changePasswordFailed": "Не удалось изменить пароль пользователя",
      "deleteUserFailed": "Не удалось удалить пользователя \"{{searchText}}\"",
      "emptyAccessRights": "Выберите права пользователя",
      "emptyFirstName": "Имя не может быть пустой строкой",
      "emptyLastName": "Фамилия не может быть пустой строкой",
      "emptyPassword": "Пароль не может быть пустой строкой",
      "incorrectUserRoles": "Дополнительные роли не соответствуют основной роли пользователя",
      "invalidEmail": "Пожалуйста, введите корректный адрес эл.почты",
      "invalidStoredPhone": "Ранее сохранённый номер {{phone}} некорректен. Введите новый номер",
      "invalidStoredPhoneContactAdministrator": "Сохранённый номер телефона некорректен. Обратитесь к администратору для его изменения",
      "invalidPassword": "Неверный пароль",
      "phoneDoesNotMatchCountry": "Ранее сохранённый номер {{phone}} не соответствует выбранной стране. Введите новый номер",
      "phoneRequired": "Номер телефона является обязательным",
      "passwordsNotSame": "Пароли не совпадают",
      "unblockUserFailed": "Не удалось разблокировать пользователя \"{{searchText}}\"",
      "updateUserInfoFailed": "Не удалось обновить информацию о пользователе",
      "userInfoNotFound": "Информация о пользователе \"{{searchText}}\" не найдена",
      "usersNotFound": "Пользователи не найдены",
      "passwordTooShort": "Пароль должен состоять из как минимум {{minLength}} символов",
      "emptyTaxAuthority": "Налоговый орган не может быть пустой строкой",
      "passwordTooLong": "Максимальная длина пароля {{maxLength}} символа",
      "passwordNotStrong": "Пароль недостаточно надежный. Пожалуйста, используйте хотя бы одну заглавную букву, одну строчную букву, одну цифру и один специальный символ",
      "passwordMinMaxLimits": "Длина пароля от {{minLength}} до {{maxLength}} символов"
    },
    "generatePassword": "Сгенерировать пароль",
    "logoutOnChangePassword": "Изменение пароля приведет к выходу из системы",
    "newPassword": "Новый пароль",
    "oldPassword": "Старый пароль",
    "otherInfo": "Дополнительная информация",
    "retypeNewPassword": "Повторите новый пароль",
    "retypePassword": "Повторите пароль",
    "removeStoredPhone": "Удалить ранее сохранённый номер",
    "selectTaxAuthority": "Выбрать налоговый орган",
    "taxOfficer": "Сотрудник налоговой",
    "userAdded": "Пользователь добавлен",
    "userManagement": "Управление пользователем",
    "ifOldPasswordIsForgotten": "Если вы забыли пароль, обратитесь к администратору",
    "userProfile": "Профиль пользователя"
  },
  "alert": {
    "alertCreationDate": "Дата создания алерта",
    "alertExecutionStatuses": {
      "FAILED": "Не выполнен",
      "RUNNING": "Выполняется",
      "SCHEDULED": "Запланирован",
      "SUCCEED": "Выполнен"
    },
    "alertStatuses": {
      "ALL": "Все",
      "CLOSED": "Закрыт",
      "IN_PROGRESS": "На исполнении",
      "OPEN": "Открыт",
      "RESOLVED": "Исполнен"
    },
    "alertType": "Тип алерта",
    "alertTypes": {
      "CASH_BOX_CERTIFICATE_IS_EXPIRED_ALERT": "Кассы с истекшим сроком сертификата",
      "CASH_BOX_WITHOUT_AUDIT_ALERT": "Кассы без технического аудита",
      "CASH_BOX_WITH_FAILED_AUDIT_ALERT": "Последний технический аудит кассы прошел неуспешно",
      "CASH_BOX_WITH_INVALID_TIME_ALERT": "Кассы с неточным временем",
      "CREATION_DATE_IS_AFTER_THAN_INSERTION_DATE_ALERT": "Кассовые чеки с расхождением реального времени",
      "INVALID_DOCUMENT_REFERENCE_ALERT": "Возврат/аннулирование по несуществующему кассовому чеку",
      "DOCUMENTS_CHAIN_GAP_ALERT": "Разрыв криптографической цепочки кассовых чеков",
      "WRONG_VAT_PERCENT_ALERT": "Совершена кассовая операция по несуществующей налоговой ставке",
      "INACTIVE_STORE_WITH_ACTIVE_CASH_BOX_ALERT": "Неактивный объект активная касса",
      "ACTIVE_STORE_WHERE_ALL_CASH_BOXES_BLOCKED_ALERT": "Все кассы активного объекта заблокированы",
      "ACTIVE_TAXPAYER_WITH_NO_ACTIVE_CASH_BOX_ALERT": "Все кассы активного налогоплательщика заблокированы",
      "CLOSED_TAXPAYER_WITH_ACTIVE_CASH_BOX_ALERT": "Налогоплательщик в статусе Закрыт имеет активные кассы",
      "ACTIVE_CASH_BOX_WITHOUT_DOCS_ALERT": "Активная касса 45 дней без кассовых операций",
      "CASHBOX_WITH_INVALID_GPS_ALERT": "Касса с некорректными или отсутствующими GPS координатами",
      "STORE_WITH_INVALID_GPS_ALERT": "Объект с некорректными или отсутствующими GPS координатами"
    },
    "assignee": "Исполнитель",
    "priorities": {
      "MAJOR": "Высокий",
      "MINOR": "Низкий",
      "NORMAL": "Средний"
    },
    "prioritiesFull": {
      "MAJOR": "Высокий приоритет",
      "MINOR": "Низкий приоритет",
      "NORMAL": "Средний приоритет"
    },
    "priority": "Приоритет",
    "schedule": "Расписание",
    "alertRunDescription": "Для проверки данного алерта будут использованы данные, собранные за указанный интервал",
    "runAlertTitle": "Выполнить проверку"
  },
  "app": {
    "address": "Адрес",
    "all": "Все",
    "cancel": "Отменить",
    "collapseAll": "Свернуть",
    "comment": "Комментарий",
    "copied": "Скопировано",
    "copy": "Копировать",
    "data": "Данные",
    "date": "Дата",
    "dateFrom": "От даты",
    "dateTo": "До даты",
    "dateTime": "Дата / Время",
    "delete": "Удалить",
    "download": "Скачать",
    "duration": "Продолжительность",
    "edit": "Редактировать",
    "file": "Файл",
    "filter": "Фильтр",
    "filters": "Фильтры",
    "from": "С",
    "hide": "Скрыть",
    "id": "ИД",
    "link": "Ссылка",
    "loading": "Загрузка...",
    "mode": "Режим",
    "name": "Наименование",
    "note": "Примечание",
    "of": "из",
    "other": "Прочее",
    "periods": {
      "currentMoment": "На текущий момент",
      "currentMonth": "Текущий месяц",
      "currentYear": "Текущий год",
      "forLast30Days": "За последние 30 дней",
      "today": "Сегодня",
      "yesterday": "Вчера"
    },
    "periodsConsts": {
      "PREVIOUS_DAY": "Прошлый день",
      "PREVIOUS_MONTH": "Прошлый месяц",
      "PREVIOUS_WEEK": "Прошлая неделя"
    },
    "quantity": "Количество",
    "save": "Сохранить",
    "settings": "Настройки",
    "showCardView": "Показать карточки",
    "showTableView": "Показать таблицу",
    "status": "Статус",
    "sum": "Сумма",
    "time": "Время",
    "timePeriodsShort": {
      "day": "д",
      "hour": "ч",
      "minute": "мин",
      "month": "мес",
      "second": "сек",
      "year": "г"
    },
    "to": "По",
    "total": "Всего",
    "type": "Тип",
    "unhide": "Развернуть",
    "periodsCommonlyUsed": {
      "today": "Сегодня",
      "yesterday": "Вчера",
      "thisWeek": "Текущая неделя",
      "thisMonth": "Текущий месяц",
      "thisYear": "Текущий год",
      "weekToDate": "Неделя",
      "monthToDate": "Месяц ",
      "yearToDate": "Год"
    },
    "last": "Последние",
    "timeUnits": {
      "minutes": "минуты",
      "hours": "часы",
      "days": "дни",
      "weeks": "недели",
      "years": "годы",
      "months": "месяцы"
    },
    "ok": "OK",
    "doNotExist": "Не существуют",
    "statuses": "Статусы",
    "noData": "Нет данных",
    "preview": "Предварительный просмотр",
    "yes": "Да",
    "no": "Нет",
    "show": "Показать",
    "shown": "Отображается",
    "fileName": "Название файла",
    "management": "Управление",
    "close": "Закрыть",
    "hints": {
      "partialSearchByOneUnable": "Поиск по части значения недоступен. Пожалуйста, введите полное значение.",
      "partialSearchByOne": "Поиск по части значения возможен, если введен только один элемент.",
      "searchByList": "Для поиска списком необходимо указать полные значения через запятую.",
      "searchByListUnable": "Поиск списком недоступен. Пожалуйста, введите одно значение или его часть.",
      "searchFieldLengthMoreThan": "Длина строки поиска не может быть больше чем {{number}}.",
      "enterValueHint": "Значение должно состоять из {{number}} символов",
      "fieldCanNotBeEmpty": "Поле не может быть пустым",
      "multipleValuesShallBeNumeric": "Значение может содержать только цифры. Возможен ввод нескольких значений через запятую.",
      "enterNumericValueHint": "Значение должно состоять из {{number}} цифр"
    },
    "filesDeleted": "Файл(ы) удалены",
    "confirmDeleteFile": "Вы действительно хотите удалить файл?",
    "confirmDeleteFiles": "Вы действительно хотите удалить выбранные файлы?",
    "numberOfSelectedFiles": "Количество выбранных файлов: {{number}}",
    "category": "Категория",
    "currentValue": "Текущее значение",
    "targetValue": "Новое значение",
    "selectTargetValue": "Пожалуйста, выберите новое значение",
    "enterTargetValue": "Пожалуйста, введите новое значение",
    "selectInterval": "Пожалуйста, выберите временной интервал",
    "selectedFilters": "Выбранные фильтры",
    "apply": "Применить",
    "enterValue": "Введите значение",
    "reloadData": "Перезагрузить данные",
    "fromForRange": "От",
    "toForRange": "До",
    "selected": "Выбрано",
    "add": "Добавить",
    "downloadZipFile": "Скачать zip файл",
    "obsolete": "Устаревший",
    "search": "Поиск",
    "clear": "Очистить",
    "scrollToTop": "Прокрутить наверх",
    "scrollToBottom": "Прокрутить вниз",
    "increaseRowHeight": "Увеличить высоту строки",
    "decreaseRowHeight": "Уменьшить высоту строки"
  },
  "cashBox": {
    "audit": "Аудит",
    "auditStatuses": {
      "failed": "Не пройден",
      "passed": "Пройден",
      "wasNotPerformed": "Аудит не проводился"
    },
    "blockAtTime": "С выбранного времени",
    "blockScheduledOn": "Блокировка запланирована",
    "cashboxRegistrationDate": "Дата регистрации кассы",
    "cashboxState": "Режим кассы",
    "cashboxStates": {
      "OFFLINE": "Офлайн",
      "ONLINE": "Онлайн"
    },
    "cashboxStatus": "Статус кассы",
    "cashboxStatuses": {
      "ACTIVE": "Активная",
      "BLOCKED": "Заблокирована",
      "BROKEN": "Сломана",
      "ELIMINATED": "Снята с регистрации",
      "REGISTRATION": "Регистрация",
      "RESET": "Обнулена",
      "SERVICE": "Сервис"
    },
    "cashboxTaxNumber": "Регистрационный номер кассы",
    "cashboxType": "Тип кассы",
    "cashboxTypes": {
      "PHYSICAL": "Физическая",
      "VIRTUAL": "Виртуальная",
      "SOFTWARE": "Программная",
      "ECOMM": "E-commerce"
    },
    "certificateExpireDate": "Дата истечения срока сертификата",
    "cleanSchedule": "Очистить расписание",
    "clock": "Время",
    "clockStatus": "Корректность времени",
    "clockStatuses": {
      "correct": "Корректно",
      "deviated": "Отклонилось"
    },
    "commentForCurrentStatus": "Комментарий к статусу кассы",
    "commentOnBlocking": "Комментарий к блокировке",
    "dateFromTo": "Задать период",
    "daysOffline": "Период в офлайне (дни)",
    "expiredCertificate": "Истек сертификат",
    "invalidTime": "Неточное время",
    "lastAuditDate": "Дата последнего технического аудита",
    "lastDocDaysAgo": "Период неактивности (дни)",
    "registeredThisYear": "Зарегистрированы в этом году",
    "pluralProps": {
      "active": "Активные",
      "blocked": "Заблокированные",
      "inactive": "Неактивные",
      "notBlocked": "Незаблокированные",
      "primary": "Постоянные",
      "temporary": "Временные"
    },
    "replacement": "Замена",
    "replacementTypes": {
      "primary": "Основная",
      "temporary": "Временная"
    },
    "timeDeviation": "Отклонение времени",
    "unblockAtTime": "С выбранного времени",
    "unblockComment": "Комментарий к разблокировке",
    "unblockingScheduled": "Разблокировка запланирована",
    "validTime": "Точное время",
    "cashboxHierarchy": "Иерархия касс",
    "cashboxHierarchyNotions": {
      "currentCashbox": "Текущая касса",
      "childCashboxes": "Кассы-замены",
      "parentCashboxes": "Кассы-доноры",
      "parent": "Донор",
      "children": "Замены",
      "child": "Замена",
      "parentCashbox": "Касса-донор"
    },
    "certificateExpireDateFilter": "Окончание срока сертификата",
    "dateLastCoordinatesUpdate": "Дата последнего обновления координат",
    "gpsTracking": "GPS-отслеживание",
    "tracking": "Отслеживание",
    "trackingAccuracy": "Точность",
    "cashboxTaskStatuses": {
      "COMPLETED": "Выполненo",
      "FAILED": "Ошибка",
      "REJECTED": "Отклонена",
      "CREATED": "Обрабатывается ..."
    },
    "blockCashbox": "Заблокировать кассу",
    "unblockCashbox": "Разблокировать кассу",
    "changeCashboxStatus": "Изменить статус кассы",
    "certificateStatus": {
      "expired": "Истек",
      "valid": "Действителен"
    }
  },
  "cashRegister": {
    "applicationArea": "Область применения",
    "attestationKey": "Ключ аттестации",
    "cashRegisterFactoryNumber": "Заводской номер кассового аппарата",
    "agent": "Агентский кассовый аппарат",
    "dateTypeByModelStatuses": {
      "ACTIVE": "Дата внесения в реестр",
      "ATTESTATION": "Дата начала аттестации",
      "ELIMINATED": "Дата исключения из реестра",
      "REGISTRATION": "Дата запроса на регистрацию",
      "REATTESTATION": "Дата последней переаттестации"
    },
    "hardwareName": "Название оборудования",
    "modelName": "Наименование модели",
    "modelStatus": "Статус модели кассового аппарата",
    "modelStatuses": {
      "ACTIVE": "Активная",
      "ATTESTATION": "Аттecтaция",
      "ELIMINATED": "Исключена",
      "REGISTRATION": "Регистрация",
      "REATTESTATION": "Повторная аттестация"
    },
    "pluralProps": {
      "active": "Активные",
      "eliminated": "Исключены"
    },
    "softwareName": "Название ПО",
    "usage": "Использование",
    "usageItems": {
      "notUsed": "Не используется",
      "used": "Используется"
    },
    "attestationResult": "Результат аттестации",
    "attestationResults": {
      "ACCEPT": "Аттестовать",
      "REJECT": "Отклонить"
    },
    "attestationErrors": {
      "sevenDaysWarning": "Процесс аттестации длится не менее 7 дней",
      "SEVEN_DAYS": "Семидневный срок для проведения аттестации еще не истек",
      "WRONG_VERSION_NAME": "Выбранный номер версии уже используется",
      "CHECKSUM_CHANGED": "В течение последних 7 дней контрольная сумма была изменена",
      "FD_VERSION_CHANGED": "В течение последних 7 дней версия фискального драйвера была изменена",
      "FD_VERSION_OUTDATED": "Устаревшая версия фискального драйвера",
      "FW_VERSION_OUTDATED": "Устаревшая версия прошивки"
    },
    "softwareVersionStatus": "Статус версии ПО",
    "softwareVersion": "Версия ПО",
    "softwareVersions": "Версии ПО",
    "versionStatuses": {
      "ACTIVE": "Активная",
      "ATTESTATION": "Аттестация",
      "OUTDATED": "Устаревшая",
      "ELIMINATED": "Исключена",
      "UNKNOWN": "Неизвестна"
    },
    "reenterSoftwareVersion": "Введите версию ПО, если вы хотите ее изменить",
    "os": "Операционная система",
    "cashRegisterCategory": "Категория кассового аппарата",
    "cashRegisterTypes": {
      "agent": "Агентский",
      "notAgent": "Не агентский",
      "portable": "Портативный",
      "stationary": "Стационарный"
    },
    "cashRegisterModelTaxNumber": "Регистрационный номер модели кассового аппарата",
    "statuses": {
      "STOCK": "На складе",
      "READY": "Подготовлен",
      "STORE": "На объекте",
      "ELIMINATED": "Ликвидирован"
    },
    "registeredWithCashBox": "Зарегистрирован с кассой",
    "cashRegisterModelsShort": "Модели касс",
    "cashRegisterModelName": "Наименование модели кассового аппарата",
    "otpCode": "Одноразовый код",
    "generateOtpCode": "Сгенерировать одноразовый код",
    "otpWarning": "Скопируйте одноразовый код и сохраните его в надежном месте. После закрытия этого окна вы не сможете восстановить код.",
    "expiredAt": "Одноразовый код действителен до: {{date}}",
    "modelTaxNumber": "Регистрационный номер модели"
  },
  "company": {
    "activity": "Вид деятельности",
    "companyName": "Наименование налогоплательщика",
    "companyStatus": "Статус налогоплательщика",
    "companyStatuses": {
      "ACTIVE": "Активный",
      "CLOSED": "Закрыт",
      "SUSPENDED": "Приостановлен"
    },
    "companyTaxNumber": "ИНН",
    "taxpayerType": "Правовой статус",
    "taxpayerTypes": {
      "LEGAL": "Юридическое лицо",
      "PHYSICAL": "Физическое лицо"
    }
  },
  "device": {
    "age": "Возраст",
    "deviceStatus": "Статус токена",
    "deviceStatuses": {
      "BROKEN": "Сломан",
      "PRODUCED": "Произведен",
      "READY": "Подготовлен",
      "RECYCLED": "Утилизирован",
      "SERVICE": "В ремонте",
      "STOCK": "На складе",
      "STORE": "На объекте",
      "FIXED": "Исправлен",
      "LOST": "Утерян"
    },
    "deviceUSBType": "Тип USB",
    "deviceUSBTypes": {
      "microB": "Микро",
      "A": "Стандарт"
    },
    "fiscalDriverVersion": "Версия фискального драйвера",
    "wearout": "Износ",
    "workability": "Уровень работопригодности",
    "workabilityLevels": {
      "INVALID": "Непригодный",
      "JUNIOR": "Молодой",
      "NEW": "Новый",
      "SENIOR": "Зрелый",
      "VETERAN": "Старый"
    },
    "experience": "Период работы",
    "firmware": "Прошивка",
    "commentForCurrentStatus": "Комментарий к статусу токена",
    "firmwarePlural": "Прошивки",
    "deviceStatusGroups": {
      "taxOfficeStock": "Склад налоговой",
      "operatorStock": "Склад оператора",
      "onObject": "На объекте",
      "inService": "В сервисе",
      "outOfUse": "Выведены из обращения"
    },
    "targetVersion": "Целевая версия",
    "resultVersion": "Установленная версия",
    "currentVersion": "Текущая версия",
    "firmwareVersion": "Версия прошивки",
    "deviceFactoryNumber": "Заводской номер токена",
    "procCount": "Количество процессоров",
    "utcOffsetSec": "Сдвиг местного времени относительно UTC (сек)",
    "ramSizeMB": "Размер оперативной памяти (Mb)",
    "productionID": "ИД партии",
    "productionPlace": "Место производства",
    "productionDate": "Дата начала производства",
    "hardwareVersion": "Версия устройства",
    "production": "Производство",
    "fiscalDriver": "Фискальный драйвер",
    "dump": "Дамп",
    "repair": "Восстановление"
  },
  "document": {
    "KTM": "Торговая наценка",
    "carNumber": "Регистрационный знак транспортного средства",
    "cashier": "Кассир",
    "creditpayContractNumber": "Номер договора рассрочки",
    "contractNumber": "Номер договора",
    "creditPayerInfo": "Информация о плательщике рассрочки",
    "documentCreatedDate": "Дата чека",
    "documentInsertedDate": "Дата получения кассового чека",
    "documentType": "Тип кассового чека",
    "firstOperation": "Дата первой операции",
    "fiscalId": "Фискальный ИД",
    "shortFiscalId": "Фискальный ИД (короткий)",
    "lastDocument": "Последний кассовый чек",
    "lastDocumentDate": "Дата последнего кассового чека",
    "lastOperation": "Дата последней операции",
    "notTaxable": "Освобожден от НДС",
    "paidInCash": "Внесено наличных",
    "parentFiscalIdLabels": {
      "correctionFiscalId": "Фискальный ИД чека коррекции",
      "creditpayFiscalId": "Фискальный ИД чека погашения рассрочки",
      "moneybackFiscalId": "Фискальный ИД чека возврата",
      "prepayFiscalId": "Фискальный ИД чека авансового платежа",
      "prepayFiscalIds": "Фискальные ИД чеков авансового платежа",
      "saleFiscalId": "Фискальный ИД чека продажи",
      "unknown": "Фискальный ИД родительского чека"
    },
    "parentFiscalId": "Родительский фискальный ИД",
    "paymentNumber": "Порядковый номер платежа",
    "paymentType": "Вид оплаты",
    "paymentTypes": "Виды оплат",
    "paymentTypesList": {
      "bonus": "Бонус",
      "cash": "Наличный",
      "cashless": "Безналичный",
      "credit": "Рассрочка",
      "prepayment": "Предоплата"
    },
    "positionInShift": "Номер кассового чека в смене",
    "price": "Цена",
    "productName": "Продукт",
    "productItems": "Товарные позиции",
    "receiptAmount": "Сумма чека",
    "residue": "Остаток, подлежащий оплате (долг)",
    "returnOfChange": "Сдача",
    "sum": "Сумма",
    "tax": "Налог",
    "taxRate": "Налоговая ставка",
    "taxSum": "Сумма налога",
    "tel": "тел",
    "total": "Итого",
    "totalTax": "Всего налог",
    "type": {
      "Correction": "Коррекция",
      "CreditPay": "Рассрочка",
      "MoneyBack": "Возврат",
      "OpenShift": "Открытие смены",
      "Prepayment": "Аванс",
      "RollBack": "Аннулирование",
      "Sale": "Продажа",
      "ZReport": "Z-отчет"
    },
    "typeForSelects": {
      "CORRECTION": "Коррекция",
      "CREDITPAY": "Рассрочка",
      "MONEY_BACK": "Возврат",
      "OPEN_SHIFT": "Открытие смены",
      "PREPAY": "Аванс",
      "ROLLBACK": "Аннулирование",
      "SALE": "Продажа",
      "Z_REPORT": "Z-отчет"
    },
    "typeFullName": {
      "correctionDocument": "Чек коррекции",
      "creditpayDocument": "Чек погашения рассрочки",
      "moneybackDocument": "Чек возврата",
      "openShiftDocument": "Чек открытия смены",
      "prepayDocument": "Чек авансового платежа",
      "rollbackDocument": "Чек аннулирования",
      "saleDocument": "Чек продажи",
      "saleDocumentCredit": "Чек продажи (рассрочка)",
      "saleDocumentWithPrepay": "Чек продажи (аванс)",
      "zReportDocument": "Чек закрытия смены (Z-отчет)"
    },
    "units": {
      "cubicMeters": "м³",
      "kilos": "кг",
      "liters": "литры",
      "meters": "м",
      "squareMeters": "м²",
      "things": "шт"
    },
    "measureUnit": "Единицы измерения",
    "zReport": {
      "correctionQuantity": "Количество",
      "correctionTotal": "Всего",
      "creditQuantity": "Количество",
      "creditTotal": "Всего",
      "firstPaymentDoc": "Первый кассовый чек №",
      "lastPaymentDoc": "Последний кассовый чек №",
      "moneyBackQuantity": "Количество",
      "moneyBackTotal": "Всего",
      "numberOfDocumentsPerShift": "Количество чеков, пробитых за смену",
      "numberOfUnsentDocuments": "Количество чеков, не отправленных в ГНС",
      "prepaymentQuantity": "Количество",
      "prepaymentTotal": "Всего",
      "rollBackQuantity": "Количество",
      "rollBackTotal": "Всего",
      "salesQuantity": "Количество",
      "salesTotal": "Всего",
      "shiftClosedDate": "Дата закрытия смены",
      "shiftOpenedDate": "Дата открытия смены",
      "turnoverTax": "Оборот по налогу"
    },
    "taxRates": {
      "0": "0%",
      "2": "2%",
      "8": "8%",
      "18": "18%",
      "OTHER": "Другая"
    },
    "taxRatesExcel": {
      "zero": "0%",
      "two": "2%",
      "eight": "8%",
      "eighteen": "18%",
      "other": "Другие"
    },
    "docNumber": "Номер кассового чека",
    "globalDocNumber": "Глобальный номер кассового чека",
    "parentDocDate": "Дата родительского чека",
    "parentDocSum": "Сумма родительского чека",
    "gasStation": "Информация об АЗС",
    "gasStationInfo": {
      "fdp": "ТРК №",
      "pump": "Помпа №",
      "gun": "Пистолет №",
      "reservoir": "Резервуар №"
    },
    "agentInfo": "Информация об агенте",
    "committentInfo": {
      "tin": "ИНН комитента",
      "name": "Наименование комитента",
      "agentContract": "Номер агентского договора",
      "agentCommission": "Процент комиссии агента"
    },
    "itemAgentCommission": "Комиссия агента",
    "bonusCardNumber": "Номер бонусной карты",
    "retrievalReferenceNumber": "Номер межбанковской транзакции (RRN)",
    "guestsCount": "Количество гостей",
    "marginPrice": "Торговая наценка по товару",
    "marginSum": " Сумма торговой наценки",
    "productCode": "Код товара",
    "productCodeType": "Тип кода товара",
    "productCodeTypes": {
      "GTIN": "GTIN",
      "ISBN": "ISBN",
      "ISSN": "ISSN",
      "EAN": "EAN",
      "DUNS": "DUNS"
    },
    "productCodeTypesTooltip": {
      "GTIN": "Глобальный номер товара",
      "ISBN": "Международный стандартный книжный номер",
      "ISSN": "Международный стандартный серийный номер",
      "EAN": "Европейский номер товара",
      "DUNS": "Универсальная система нумерации данных"
    },
    "markingCode": "Код маркировки",
    "documentVersion": "Версия формата чека",
    "itemHash": "Хэш наименований товаров",
    "markingCodes": "Коды маркировки",
    "paymentInfo": "Информация о платеже",
    "operationInfo": "Информация об операции",
    "openShiftOperationNumber": "Номер операции открытия смены",
    "zReportOperationNumber": "Номер операции закрытия смены",
    "currencyReport": "Отчет по валюте",
    "numberOfDocuments": "Количество чеков",
    "taxDetails": "Детализация налога",
    "notTaxableSum": "Сумма, освобожденная от НДС",
    "creditPaymentSum": "Сумма выплаты по рассрочке",
    "approvalCode": "Код подтверждения",
    "interbankTransactions": "Межбанковские транзакции",
    "restoredDocument": "Чек восстановлен из бэкапа токена",
    "restoredFromBackup": "Восстановлен из бэкапа токена",
    "restored": "Восстановлен",
    "paid": "Оплачено"
  },
  "domain": {
    "accountMenu": "Меню учетной записи",
    "addListItem": "Добавить элемент списка",
    "alert": "Алерт",
    "alerts": "Алерты",
    "block": "Заблокировать",
    "cashRegister": "Кассовый аппарат",
    "cashRegisterModel": "Модель кассового аппарата",
    "cashRegisterModels": "Модели кассовых аппаратов",
    "cashRegisters": "Кассовые аппараты",
    "cashbox": "Касса",
    "cashboxes": "Кассы",
    "companies": "Налогоплательщики",
    "company": "Налогоплательщик",
    "currency": "Валюта",
    "device": "Токен",
    "devices": "Токены",
    "document": "Кассовый чек",
    "documents": "Кассовые чеки",
    "elements": "Элементы",
    "factoryNumber": "Заводской номер",
    "financial": "Финансовые",
    "home": "Главная",
    "info": "Информация",
    "infographic": "Инфографика",
    "legalAddress": "Юридический адрес",
    "loadingData": "Загрузка данных...",
    "map": "Карта",
    "nowInSystem": "Сейчас в системе",
    "operator": "Оператор",
    "operators": "Операторы",
    "parameters": "Параметры",
    "period": "Период",
    "registrationDate": "Дата регистрации",
    "registrationNumber": "Регистрационный номер",
    "registry": "Реестр",
    "report": "Отчет",
    "reports": "Отчеты",
    "retriesCount": "Количество попыток",
    "rowsPerPage": "Строк на странице",
    "searchBy": "Поиск по",
    "searchDocument": "Поиск кассового чека",
    "security": "Безопасность",
    "select": "Выбрать",
    "showNew": "Показать новые",
    "start": "Начало",
    "statistics": "Статистика",
    "statusDate": "Дата установки статуса",
    "store": "Объект",
    "stores": "Объекты",
    "taxAuthority": "Налоговый орган",
    "taxationType": "Форма налогообложения",
    "taxationTypes": {
      "INCOME": "Подоходный налог",
      "PROFIT": "Налог на прибыль",
      "SIMPLIFIED": "Упрощенный налог ",
      "VAT": "НДС",
      "EMPTY": "Нет данных"
    },
    "taxes": "Налоги",
    "technical": "Технические",
    "turnover": "Оборот",
    "turnoverByActivity": "Обороты по видам деятельности",
    "turnovers": "Обороты",
    "unblock": "Разблокировать",
    "update": "Обновить",
    "user": "Пользователь",
    "users": "Пользователи",
    "showNextPageReports": "Следующие {{limit}} элементов",
    "showNextPageCashboxes": "Следующие {{limit}} касс",
    "showNextPageDevices": "Следующие {{limit}} токенов",
    "showNextPageDocuments": "Следующие {{limit}} чеков",
    "showNextPageTaxpayers": "Следующие {{limit}} налогоплательщиков",
    "deregistrationDate": "Дата снятия с регистрации",
    "registration": "Регистрация",
    "photos": "Фотографии",
    "upload": "Загрузить",
    "dropZoneText": "Перетяните фото сюда или нажмите, чтобы выбрать",
    "dropZoneTitle": "Загрузить фотографии",
    "maxNumberOfPhotos": "Максимальное количество фотографий: {{numberOfFiles}}",
    "addPhotos": "Добавить фотографии",
    "inspection": "Проверка",
    "inspections": "Проверки",
    "dropZoneMaxFilesUploaded": "Загружено максимальное количество фотографий",
    "setPhotoAsPreview": "Сделать фотографией для превью",
    "photoIsPreview": "Фотография для превью",
    "deletePhoto": "Удалить фотографию",
    "attachPhotos": "Прикрепите от 1 до {{maxNumber}} фотографий",
    "fileSizeAndFormats": "Размер файла не более {{fileSize}} Мб, доступные форматы {{formats}}",
    "showNextPageLocations": "Следующие {{limit}} позиций",
    "locationData": "Данные о местоположении",
    "showNextPageStores": "Следующие {{limit}} объектов",
    "showNextPageOperators": "Следующие {{limit}} операторов",
    "result": "Результат",
    "activate": "Активизировать",
    "eliminate": "Исключить",
    "dropZoneDocumentsText": "Перетяните документы сюда или нажмите, чтобы выбрать",
    "attachDocuments": "Пожалуйста, прикрепите до {{maxNumber}} документов",
    "fileSizeAndFormatsDocuments": "Каждый документ не более {{fileSize}} Мб, доступные форматы {{formats}}",
    "dropZoneMaxDocumentsUploaded": "Загружено максимальное количество документов",
    "addDocuments": "Добавить документы",
    "addedByUser": "Добавлен пользователем",
    "checkSum": "Контрольная сумма",
    "creationDate": "Дата создания",
    "updatedDate": "Дата обновления",
    "inactivity": "Неактивность",
    "generalInfo": "Общая информация",
    "additionalInfo": "Дополнительная информация",
    "country": "Страна",
    "code": "Код",
    "requestDate": "Дата запроса",
    "statusDetails": "Детализация статуса",
    "statusChangeDate": "Дата изменения статуса",
    "version": "Версия",
    "architecture": "Архитектура",
    "change": "Изменить",
    "hints": {
      "incorrectStoreTaxNumber": "Неверный формат кода объекта (10 цифр - 5(7) цифр).",
      "incorrectCompanyTaxNumber": "Неверный формат ИНН (10 цифр).",
      "incorrectCashboxTaxNumber": "Неверный формат регистрационного номера кассы (10 символов).",
      "incorrectRrn": "Неверный формат RRN (8-16 символов).",
      "incorrectFiscalId": "Неверный фискальный ИД (42-46 base58 символов)."
    },
    "certificate": "Сертификат",
    "registrationNumberShort": "Рег. номер",
    "service": "Сервис",
    "initialization": "Инициализация",
    "addCashboxes": "Добавить кассы",
    "operationStatus": "Статус операции",
    "maxNumberOfFiles": "Допустимое количество файлов: {{limit}}",
    "pictureSizeAndFormats": "Каждая фотография не более {{fileSize}} Мб, доступные форматы {{formats}}",
    "devicesList": "Список токенов",
    "updateData": "Обновить данные",
    "logs": "Логи",
    "environment": "Окружение",
    "byDetailsLevel": "По уровню детализации",
    "fiscalDriverPublicKey": "Публичный ключ фискального драйвера"
  },
  "errors": {
    "failedLoadList": "Ошибка загрузки списка \"{{listName}}\"",
    "failedTryAgain": "Не удалось выполнить, пожалуйста, попробуйте снова",
    "failedUploadFile": "Не удалось загрузить файл",
    "failedUploadFileName": "Не удалось загрузить файл: {{fileName}}",
    "noResultsFound": "По запросу ничего не найдено",
    "notFoundByParams": "По примененным параметрам ничего не найдено",
    "requestFailed": "Запрос не выполнен",
    "somethingWrong": "К сожалению, что-то пошло не так. Попробуйте снова",
    "toLessThanFrom": "Значение 'До' не может быть меньше значения 'От'",
    "tokenNotReceived": "Ошибка верификации действий пользователя",
    "failedUploadMaxFiles": "Не удалось загрузить файл, проверьте максимально допустимое количество файлов",
    "commentNotEmpty": "Поле комментария не должно быть пустым",
    "commentLengthError": "Длина комментария не может быть больше {{maxLength}} символов",
    "failedToGetUrl": "Не удалось получить URL для скачивания файла {{fileName}}",
    "failedToDeleteFiles": "Не удалось удалить файл(ы)",
    "sameCurrentAndTargetValues": "Текущее и новое значения совпадают",
    "noMeaningfulValue": "Пожалуйста, введите применимое значение."
  },
  "operator": {
    "operatorName": "Наименование оператора",
    "operatorTaxNumber": "ИНН оператора",
    "operatorTaxNumberShort": "ИНН",
    "serviceOperators": "Обслуживающие операторы"
  },
  "store": {
    "address": {
      "building": "Дом",
      "city": "Город",
      "region": "Регион",
      "street": "Улица"
    },
    "storeAddress": "Адрес объекта",
    "storeСategories": {
      "ADVERTISING": "РЕКЛАМНЫЕ УСЛУГИ",
      "CATERING": "ОБЩЕСТВЕННОЕ ПИТАНИЕ",
      "COMMUNICATION": "УСЛУГИ СВЯЗИ",
      "EDUCATION": "ОБРАЗОВАНИЕ",
      "ENTERTAINMENT": "ОБЪЕКТЫ ОТДЫХА И РАЗВЛЕЧЕНИЯ",
      "FINANCE": "ФИНАНСЫ",
      "GAS_STATION": "АЗС",
      "HEALTH_CARE": "ЗДРАВООХРАНЕНИЕ",
      "HOTELS": "ГОСТИНИЦЫ",
      "OTHER": "ПРОЧИE",
      "PRODUCTION": "ПРОИЗВОДСТВО И ПОТРЕБЛЕНИЕ",
      "PUBLIC_SERVICES": "УСЛУГИ НАСЕЛЕНИЮ",
      "QUARRY": "КАРЬЕР",
      "RENT": "АРЕНДА",
      "TICKETS": "ПРОДАЖА БИЛЕТОВ",
      "TRADE": "ТОРГОВЛЯ"
    },
    "storeName": "Наименование объекта",
    "storeStatus": "Статус объекта",
    "storeStatuses": {
      "ACTIVE": "Активный",
      "CLOSED": "Закрыт",
      "ELIMINATED": "Ликвидирован",
      "SUSPENDED": "Приостановлен"
    },
    "storeTaxAuthority": "Налоговый орган",
    "storeTaxNumber": "Код объекта",
    "storeTaxNumberShort": "Код",
    "storeType": "Вид деятельности",
    "storeWebSite": "Вeб-сайт",
    "storeTypes": {
      "ADVERTISING": "Рекламные услуги",
      "AUTO_STATION": "Автовокзал",
      "BANK": "Банк",
      "BEACH": "Пляж",
      "BEAUTY": "Парикмахерские и салоны красоты",
      "CAFE": "Кафе (столовая)",
      "CAR_SERVICE": "Услуги автосервиса",
      "CELEBRATIONS": "Дома торжеств",
      "CEREMONIAL_SERVICES": "Церемониальные услуги",
      "COMMUNAL_SERVICES": "Жилищно-хозяйственный объект",
      "COMMUNICATION": "Услуги связи",
      "COMPUTERS": "Деятельности связанные с компьютером",
      "CONSUMERS": "Объект потребительских услуг",
      "CULTURAL": "Объекты культуры",
      "DENTIST": "Стоматолог",
      "ENTERTAINMENT": "Объекты отдыха и развлечения",
      "EXCHANGE": "Пункты обмена валюты",
      "EXHIBITIONS": "Выставочные салоны",
      "GAMING": "Азартные игры",
      "GAS_STATION": "Автозаправочная станция",
      "HEALTH_RESORT": "Санаторно-курортные объекты",
      "HEALTH_SERVICES": "Услуги здравоохранения",
      "HIGH_EDUCATION": "Высшее учебное заведение",
      "HOSPITAL": "Санаторий / больница / амбулатория",
      "HOSTEL": "Услуги общежития",
      "HOTELS": "Гостиницы",
      "INSURANCE": "Страхование",
      "INTRENET_CLUB": "Интернет клуб",
      "LEGAL_SERVICES": "Нотариальная контора / юридические услуги",
      "MAGAZINES": "Продажа газет и журналов",
      "MANUFACTURING": "Производственный цех",
      "MARKET": "Базар",
      "MOBILE_TRADE": "Мобильная торговля",
      "MOTEL_CAMPING": "Мотель / кемпинг",
      "MOTEL_RESTAURANT": "Мотель / ресторан",
      "NUTRITION": "Питание",
      "OFFICES": "Офис",
      "PARKING": "Автомобильные стоянки",
      "PAWNSHOP": "Ломбард",
      "PAYMENT_TERMINALS": "Платежный терминал",
      "PHARMACY": "Аптека / оптика",
      "PHOTOS": "Фотоателье",
      "PRESCHOOL": "Дошкольные образовательные учреждения",
      "PUBLIC_CATERING": "Общественное питание",
      "PUBLISHING": "Издательство газет",
      "QUARRY": "Карьер",
      "RENT": "Аренда",
      "RESTAURANTS": "Рестораны",
      "RETAIL": "Розничная торговля",
      "SCHOOLS": "Школы и ПТУ",
      "SPORT": "Оздоровительно-спортивные комплексы",
      "STOCK": "Склад",
      "TAXI": "Такси",
      "TEAHOUSE": "Чайхана",
      "TICKETS": "Продажа билетов",
      "TOURISM": "Туризм-экскурсии",
      "TRAININGS": "Подготовительные курсы",
      "TRANSPORTATION": "Пассажирские и грузовые перевозки",
      "WASTE_RECEPTION": "Центр по принятию отходов",
      "WHOLESALE": "Оптовая продажа"
    },
    "storeMainActivities": {
      "TRADE": "Торговля",
      "CATERING_SERVICES": "Общественное питание",
      "OTHER_SERVICES": "Прочие услуги",
      "PRODUCTION_FACILITY_NON_FOOD": "Производственное предприятие (непродовольственное)",
      "SPORTS_LEISURE_AND_ENTERTAINMENT_SERVICES": "Услуги в области спорта, отдыха и развлечений",
      "HEALTHCARE_SERVICES": "Услуги здравоохранения",
      "HOUSEHOLD_SERVICES": "Бытовые услуги",
      "PRODUCTION_FACILITY_FOOD": "Производственное предприятие (продовольственное)",
      "COMMUNICATION_SERVICES": "Услуги связи",
      "TRAVEL_SERVICES": "Туристические услуги",
      "PRODUCTION_FACILITY_BEVERAGES": "Производственное предприятие (напитки)",
      "PRODUCTION_FACILITY": "Производственное предприятие",
      "EDUCATION_SERVICES": "Образовательные услуги",
      "TRANSPORTATION_SERVICES": "Транспортные услуги",
      "FINANCIAL_SERVICES": "Финансовые услуги"
    },
    "storeMiddleActivities": {
      "RETAIL_TRADE": "Розничная торговля",
      "CAFE_RESTAURANT": "Кафе-ресторан",
      "RENTAL_FACILITY": "Аренда объектов",
      "CELEBRATION_HOUSE": "Дом торжеств",
      "CAR_SERVICE": "Автосервис",
      "FACTORY": "Завод",
      "WHOLESALE_TRADE": "Оптовая торговля",
      "OFFICE": "Офис",
      "TICKET_SALES": "Продажа билетов",
      "LEISURE_AND_ENTERTAINMENT_CENTER": "Центр отдыха и развлечений",
      "HOSPITAL": "Больница",
      "CULTURAL_OBJECT": "Объект культуры",
      "SPORTS_CENTER": "Спортивный комплекс",
      "TAILOR": "Портной",
      "WAREHOUSE": "Склад",
      "WATCH_REPAIRING": "Ремонт часов",
      "CEREMONY_HOUSE": "Дом для церемоний",
      "TELEVISION_AND_RADIO_BROADCASTING": "Телевидение и радиовещание",
      "HOTEL": "Гостиница",
      "DENTISTRY": "Стоматология",
      "HAIRDRESSERS_AND_BEAUTY_SALONS": "Парикмахерские и салоны красоты",
      "DRY_CLEANING": "Химчистка",
      "AGRICULTURE": "Сельское хозяйство",
      "SHOPPING_CENTER_MARKETPLACE": "Торговый центр, рынок",
      "FASHION_HOUSE_ATELIER": "Дом моды, ателье",
      "POULTRY_AND_LIVESTOCK_FARMING": "Птицеводство и животноводство",
      "PHONE_REPAIR": "Ремонт телефонов",
      "TEAHOUSE": "Чайная",
      "PRE_SCHOOL_EDUCATION": "Дошкольное образование",
      "MOBILE_COMMUNICATION_CUSTOMER_SERVICE": "Служба поддержки клиентов мобильной связи",
      "BUS_STATION": "Автовокзал",
      "TRAINING_COURSES": "Учебные курсы",
      "MOBILE_PHONE_REPAIR": "Ремонт мобильных телефонов",
      "FURNITURE_REPAIR": "Ремонт мебели",
      "SOCIAL_ASSISTANCE": "Оказание социальной помощи",
      "MEDICAL_HEALTH_CARE_SERVICES": "Медико-санитарное обслуживание",
      "LOMBARD": "Ломбард",
      "EXHIBITION_HALL": "Выставочный зал",
      "LAUNDRY": "Прачечная",
      "CAR_PARKING": "Автостоянка",
      "FREIGHT_TRANSPORTATION_OFFICE": "Офис грузоперевозок",
      "RECEPTION_POINT_FOR_METALS_AND_OTHER_WASTE": "Пункт приема металлов и других отходов",
      "WEDDING_DRESS_RENTAL": "Прокат свадебных платьев",
      "ANIMAL_TRAINING_AND_CARE": "Дрессировка и уход за животными",
      "COMPUTER_REPAIR": "Ремонт компьютеров",
      "COURIER_OR_DELIVERY_SERVICE": "Курьер или служба доставки",
      "BOILER_REPAIR": "Ремонт котлов",
      "JEWELLERY_SERVICES": "Ювелирные услуги",
      "NOTARY_OFFICE_LEGAL_SERVICES": "Нотариальная контора, юридические услуги",
      "MEDICAL_CENTER": "Медицинский центр",
      "TELECOMMUNICATION_ACTIVITIES": "Деятельность в области телекоммуникаций",
      "DECORATIVE_WORKS": "Декоративные работы",
      "RENTAL_OF_SPORTS_AND_LEISURE_GOODS": "Аренда товаров для спорта и отдыха",
      "PHOTO_STUDIO": "Фотостудия",
      "CLOTHING_RENTAL": "Прокат одежды",
      "COMPUTER_SERVICES": "Компьютерные услуги",
      "GLASS_WASTE_COLLECTION_POINT": "Пункт приема стеклотары",
      "INTERNET_SUPPLY_SERVICE": "Сервис интернет-поставки",
      "GAMBLING": "Азартные игры",
      "INTERNET_CLUB": "Интернет-клуб",
      "POST_OFFICE": "Почтовое отделение или филиал",
      "SHOE_REPAIR": "Ремонт обуви",
      "PHOTO_PRINTING_SHOP": "Салон фотопечати",
      "DECORATION_OF_TRAYS": "Украшение подносов",
      "SANATORIUM": "Санаторий",
      "EYEGLASSES_REPAIR": "Ремонт очков",
      "TOURIST_CAMPS_AND_RESORTS": "Туристические лагеря и базы отдыха",
      "CURRENCY_EXCHANGE_POINT": "Пункт обмена валюты",
      "VIDEO_COPYING_SERVICE": "Копирование видеозаписей",
      "REPAIR_AND_PAINTING_OF_METAL_PRODUCTS": "Ремонт и покраска металлических изделий",
      "DORMITORY": "Общежитие",
      "BICYCLE_REPAIR": "Ремонт велосипеда",
      "CLEANING_SERVICE": "Клининговые услуги",
      "PASSENGER_TRANSPORTATION_OFFICE": "Управление пассажирских перевозок",
      "KEY_MAKING_AND_REPAIR_SERVICE": "Услуга изготовления и ремонта ключей",
      "VEHICLE_AND_EQUIPMENT_REPAIR": "Ремонт автомобилей и оборудования",
      "RENTAL_OF_VIDEO_TAPES_AND_DISCS": "Прокат видеокассет и дисков",
      "AIRPORT": "Аэропорт",
      "MANAGEMENT_OF_APARTMENT_BUILDINGS": "Управление многоквартирными домами",
      "CLOTHING_REPAIR": "Ремонт одежды",
      "RESORT_AREA": "Курортная зона",
      "REPAIR_OF_HOUSEHOLD_APPLIANCES": "Ремонт бытовой техники",
      "TOILET": "Туалет",
      "CARPET_CLEANING": "Чистка ковров",
      "WEDDING_CAR_DECORATION": "Оформление свадебных автомобилей",
      "TURNER": "Токарь",
      "HIGHER_EDUCATION": "Высшее образование",
      "POTTERY_TINWORK_AND_DISHWARE_PRODUCTION": "Производство гончарных, жестяных изделий, посуды",
      "PUMP_REPAIR": "Ремонт насосов",
      "SCHOOL_VOCATIONAL_COLLEGE": "Школа, профессиональное училище",
      "TINWORKER": "Жестянщик",
      "FINE_ARTS": "Изобразительное искусство",
      "SHIP_REPAIR_AND_MAINTENANCE": "Ремонт судов и их техническое обслуживание"
    },
    "storeLowerActivities": {
      "SELLING_ALCOHOLIC_BEVERAGES": "Продажа алкогольных напитков",
      "SELLING_WATCHES": "Продажа часов",
      "RESTAURANT": "Ресторан",
      "RENTAL_FACILITY": "Аренда объектов",
      "FUEL_SELLING": "Продажа топлива",
      "SELLING_PETROLEUM_PRODUCTS": "Продажа нефтепродуктов",
      "FUEL_FILLING_POINTS": "Заправочные станции",
      "CELEBRATION_HOUSE": "Дом торжеств",
      "FOODS_SELLING": "Прдажа продовольственных товаров",
      "MARKET_NETWORK_FOOD": "Сеть системных маркетов (продуктовые)",
      "CAR_SERVICE": "Автосервис",
      "SELLING_WOMEN_CLOTHING": "Продажа женской одежды",
      "FURNITURE_MANUFACTURING": "Производство мебели",
      "GAS_FILLING_POINTS": "Газозаправочные станции",
      "SELLING_TOBACCO_PRODUCTS": "Продажа табачных изделий",
      "SECURITY_SERVICE": "Охранная служба",
      "SELLING_BIJOUTERIE_AND_ACCESSORIES": "Продажа бижутерии и аксессуаров",
      "SELLING_STATIONERY_SUPPLIES": "Продажа канцелярских товаров",
      "AIR_TICKET_OFFICE": "Авиакасса",
      "SELLING_MOBILE_PHONES": "Продажа мобильных телефонов",
      "SELLING_COSMETICS_AND_PERFUMERY": "Продажа косметики и парфюмерии",
      "SELLING_CHILDREN_CLOTHING": "Продажа детской одежды",
      "SELLING_HOUSEHOLD_GOODS": "Продажа хозяйственных товаров",
      "PLANTS_SELLING": "Продажа растений",
      "SELLING_SUGAR_CHOCOLATE_AND_CONFECTIONERY": "Продажа сахара, шоколада и кондитерских изделий",
      "FOOTWEAR_SELLING": "Продажа обуви",
      "BOOKS_SELLING": "Продажа книг",
      "GAMES_ROOM": "Игровой зал",
      "KITCHENWARE_SELLING": "Продажа посуды и кухонной утвари",
      "CAR_SELLING": "Продажа автомобилей",
      "SOUVENIR_MANUFACTURING": "Производство сувениров",
      "COFFEE_HOUSE": "Кофейня",
      "FURNITURE_SELLING": "Продажа мебели",
      "SELLING_SILVER_AND_OTHER_METAL_JEWELLERY": "Продажа ювелирных изделий из серебра и других металлов",
      "CAFE": "Кафе",
      "MAIL_OR_INTERNET_SALES": "Продажа через почту или интернет",
      "CLINIC": "Клиника",
      "CINEMA": "Кинотеатр",
      "SELLING_MEAT_AND_MEAT_PRODUCTS": "Продажа мяса и мясных продуктов",
      "SPORTS_HALL": "Спортзал",
      "SELLING_HUNTING_SUPPLIES": "Продажа товаров для охоты",
      "SELLING_SWEETS": "Продажа конфет",
      "TAILOR": "Портной",
      "SELLING_ELECTRICAL_HOUSEHOLD_GOODS": "Продажа электробытовых товаров",
      "CANTEEN": "Столовая",
      "SELLING_COMPUTERS": "Продажа компьютеров",
      "STORAGE_AND_WAREHOUSING_SERVICES": "Услуги хранения и складирования",
      "ENTERTAINMENT_CENTER": "Развлекательный центр",
      "PRODUCTION_OF_SAUSAGES": "Производство колбасных изделий",
      "LUMINAIRE_SELLING": "Продажа светильников",
      "CONFECTIONERY_PRODUCTION": "Производство кондитерских изделий",
      "SELLING_INDUSTRIAL_GOODS": "Продажа промышленных товаров",
      "SELLING_CONSTRUCTION_MATERIALS": "Продажа строительных материалов",
      "TABLEWARE_SELLING": "Продажа столовой утвари",
      "SELLING_SPORTS_GOODS": "Продажа спортивных товаров",
      "SELLING_CHEMICALS": "Продажа химической продукции",
      "SELLING_CAR_SPARE_PARTS": "Продажа автомобильных запчастей",
      "SELLING_PHARMACEUTICAL_GOODS": "Продажа фармацевтических товаров",
      "FISH_RESTAURANT": "Рыбный ресторан",
      "JEWELLERY_SELLING": "Продажа ювелирных изделий",
      "RETAIL_TRADE_OF_FERTILIZERS_SEEDS_AND_PESTICIDES": "Розничная продажа удобрений, семян и пестицидов",
      "GIFTS_SELLING": "Продажа подарков",
      "WATCH_REPAIRING": "Ремонт часов",
      "SELLING_ANIMALS": "Продажа животных",
      "BEER_HALL": "Пивная",
      "CEREMONY_HOUSE": "Дом церемоний",
      "SELLING_DAIRY_PRODUCTS": "Продажа молочных продуктов",
      "SELLING_OPTICAL_GOODS": "Продажа оптических товаров",
      "TRANSLATION_SERVICES": "Услуги перевода",
      "BREAD_PRODUCTION": "Производство хлеба",
      "PLASTICS_MANUFACTURING": "Производство пластиковых изделий",
      "HOTEL": "Отель",
      "SELLING_VETERINARY_GOODS": "Продажа ветеринарных товаров",
      "PIZZA_SHOP": "Пиццерия",
      "SELLING_ANIMAL_FEED": "Продажа кормов для животных",
      "MOTEL": "Мотель",
      "DENTAL_CLINIC": "Стоматологическая клиника",
      "SELLING_CERAMICS_TILES": "Продажа керамической плитки",
      "PRODUCTION_OF_PLASTIC_DOORS_AND_WINDOWS": "Производство пластиковых дверей и окон",
      "WOMEN_BEAUTY_SALON": "Женский салон красоты",
      "SELLING_CURTAINS": "Продажа штор",
      "PRODUCTION_OF_OTHER_MACHINERY_AND_TOOLS": "Производство прочих машин, оборудования и инструментов",
      "PUBLIC_ADMINISTRATIVE_BUILDING": "Общественное административное здание",
      "TOUR_OPERATOR": "Туроператор",
      "DENTAL_OFFICE": "Стоматологический кабинет",
      "PRODUCTION_OF_ALCOHOLIC_BEVERAGES": "Производство алкогольных напитков",
      "SELLING_HEATING_SYSTEMS": "Продажа отопительных систем",
      "REFRACTORY_MATERIALS_MANUFACTURING": "Производство огнеупорных материалов",
      "DRY_CLEANING_SERVICES": "Услуги химчистки",
      "GROWING_OTHER_PLANTS": "Выращивание прочих растений",
      "SELLING_TEXTILE_MATERIALS": "Продажа текстильных материалов",
      "SELLING_FLOUR_AND_FLOUR_PRODUCTS": "Продажа муки и мучных изделий",
      "PRODUCTION_OF_RUBBER_TYRES_TUBES_AND_PIPES": "Производство резиновых шин, камер и труб",
      "PRODUCTION_OF_OTHER_CONCRETE_PRODUCTS": "Производство прочих изделий из бетона, гипса и цемента",
      "SOUVENIRS_SELLING": "Продажа сувениров",
      "BAGS_SELLING": "Продажа сумок",
      "BAR": "Бар",
      "MEN_BARBER_SHOP": "Мужская парикмахерская",
      "SHOPPING_CENTER": "Торговый центр",
      "FASHION_HOUSE_ATELIER": "Дом моды, ателье",
      "PLUMBING_EQUIPMENT_INSTALLATION_SERVICES": "Услуги по установке систем водоснабжения и санитарного оборудования",
      "SELLING_STYROFOAM": "Продажа пенопласта",
      "POULTRY_FARMING": "Птицеводство",
      "PRODUCTION_OF_MILK_AND_DAIRY_PRODUCTS": "Производство молока и молочных продуктов",
      "PHONE_REPAIR": "Ремонт телефонов",
      "SELLING_EQUIPMENT_FOR_MINING_AND_CONSTRUCTION": "Продажа машин и оборудования для горных и строительных работ",
      "TEAHOUSE": "Чайная",
      "TOYS_SELLING": "Продажа игрушек",
      "MANUFACTURING_OF_OTHER_FINISHED_METAL_PRODUCTS": "Производство прочих готовых металлических изделий",
      "PET_SHOP": "Зоомагазин",
      "ADVERTISING_SERVICE": "Рекламные услуги",
      "POLYCLINIC": "Поликлиника",
      "MANUFACTURING_OF_OTHER_FOOD_PRODUCTS": "Производство прочих продуктов питания, не входящих в другие группы",
      "SELLING_SCHOOL_SUPPLIES": "Продажа школьных принадлежностей",
      "PARK": "Парк",
      "TOUR_AGENT": "Туристический агент",
      "SELLING_OTHER_MACHINES_AND_EQUIPMENT": "Продажа прочих машин и оборудования",
      "SELLING_AGRICULTURAL_MACHINES_AND_EQUIPMENT": "Продажа сельскохозяйственных машин и оборудования",
      "PRODUCTION_OF_OTHER_NON_FOOD_PRODUCTS": "Производство прочих непродовольственных товаров",
      "PRODUCTION_OF_FLOUR_MILLING_INDUSTRY_PRODUCTS": "Производство продукции мукомольной промышленности",
      "PRODUCTION_OF_MEN_CLOTHING": "Производство мужской одежды",
      "PRODUCTION_OF_COMBI_RADIATORS": "Производство комбинированных радиаторов",
      "CATERING_SERVICE": "Кейтеринг",
      "SELLING_ROOF_COVERINGS": "Продажа кровельных покрытий",
      "BEACH": "Пляж",
      "TANDOOR_OVEN": "Тандирная печь",
      "REPAIR_OF_OTHER_PRODUCTS_EQUIPMENT_AIRCRAFTS": "Ремонт прочих изделий, оборудования, летательных аппаратов",
      "SELLING_SANITARY_GOODS": "Продажа сантехнических товаров",
      "FLOUR_PRODUCTION": "Производство муки",
      "SELLING_MEDICAL_AND_ORTHOPAEDIC_GOODS": "Продажа медицинских и ортопедических товаров",
      "SPA_SALON": "Спа-салон",
      "HAZELNUT_PROCESSING": "Переработка фундука",
      "GYM_FITNESS_HALL": "Фитнес-зал",
      "NEWSPAPER_STAND": "Газетный киоск",
      "FOOTBALL_FIELD": "Футбольное поле",
      "SELLING_OTHER_PHONES": "Продажа прочих телефонов",
      "PRODUCTION_OF_PILLOWS_MATTRESSES": "Производство подушек, матрасов и подобных предметов",
      "PRODUCTION_OF_PLASTIC_BAGS": "Производство полиэтиленовых пакетов",
      "PRODUCTION_OF_CHEMICAL_PRODUCTS": "Производство химических продуктов",
      "LIMESTONE_AND_GYPSUM_MINING": "Добыча известняка и гипса",
      "SELLING_FLOWERS": "Продажа цветов",
      "PRODUCTION_OF_MARBLE": "Производство мрамора",
      "PRODUCTION_OF_PACKAGING_FROM_OTHER_MATERIALS": "Производство упаковки из прочих материалов",
      "CARPETS_SELLING": "Продажа ковров",
      "SELLING_AUDIO_AND_VIDEO_EQUIPMENT": "Продажа аудио и видео оборудования",
      "INSTALLATION_ELECTRIC_HEATING_SYSTEMS": "Услуги по установке электрических отопительных систем",
      "SELLING_TELECOMMUNICATION_EQUIPMENT": "Продажа телекоммуникационного оборудования",
      "GLASS_SELLING": "Продажа стекла",
      "FODDER_PRODUCTION": "Производство кормов",
      "RETAIL_SELLING_NON_ALCOHOLIC_BEVERAGES": "Розничная продажа безалкогольных напитков",
      "WALLPAPER_SELLING": "Продажа обоев",
      "PRODUCTION_OF_PARQUET_FLOORING": "Производство паркетных полов",
      "KINDERGARTEN": "Детский сад",
      "CAR_MARKET": "Автомобильный рынок",
      "SELLING_WOODEN_MATERIALS": "Продажа древесных материалов",
      "MOBILE_COMMUNICATION_CUSTOMER_SERVICE": "Служба поддержки клиентов мобильной связи",
      "SELLING_FERTILISERS_AND_AGROCHEMICAL_PRODUCTS": "Продажа удобрений и агрохимических продуктов",
      "OPERATION_OF_BUS_STATIONS": "Эксплуатация автобусных станций",
      "TRAINING_CENTER": "Учебный центр",
      "SURGERY_ROOM": "Операционная",
      "ICE_CREAM_PRODUCTION": "Производство мороженого",
      "SELLING_NUTRITIONAL_SUPPLEMENTS": "Продажа пищевых добавок",
      "METAL_PROCESSING_AND_COATING": "Обработка и покрытие металлов",
      "PRODUCTION_OF_CRACKERS_AND_COOKIES": "Производство сухарей и печенья",
      "PAPER_AND_CARDBOARD_PRODUCTION": "Производство бумаги и картона",
      "MANUFACTURING_OF_CONFECTIONERY_FROM_SUGAR": "Производство кондитерских изделий из сахара",
      "CUSTOMS_WAREHOUSES_STORAGES_FREE_WAREHOUSES": "Создание таможенных складов, временных складов, свободных складов",
      "FOOTWEAR_PRODUCTION": "Производство обуви",
      "SELLING_PAINT_AND_VARNISH_MATERIALS": "Продажа лакокрасочных материалов",
      "GREENHOUSE": "Теплица",
      "INSTALLATION_HEATING_VENTILATION_AIR_CONDITIONING_SYSTEMS": "Услуги по монтажу систем отопления, вентиляции, кондиционирования",
      "CATTLE_BREEDING": "Разведение крупного рогатого скота",
      "FRUIT_AND_VEGETABLES_SELLING": "Продажа фруктов и овощей",
      "PRODUCTION_OF_NON_ALCOHOLIC_BEVERAGES": "Производство безалкогольных напитков",
      "SUGAR_PRODUCTION": "Производство сахара",
      "MEDICAL_OFFICE": "Медицинский кабинет",
      "PRODUCTION_OF_MEAT_PRODUCTS": "Производство мясных продуктов",
      "MOBILE_PHONE_REPAIR": "Ремонт мобильных телефонов",
      "FURNITURE_REPAIR": "Ремонт мебели",
      "BATHHOUSE": "Баня",
      "CAKE_PRODUCTION": "Производство тортов",
      "SELLING_METAL_AND_METAL_PRODUCTS": "Продажа металла и металлических изделий",
      "PRINTING_HOUSE": "Типография",
      "TIRE_SERVICE": "Шиномонтаж",
      "CARE_FOR_PERSONS_WITH_ALCOHOL_AND_DRUG_ABUSE_PROBLEMS": "Уход за лицами с психическими расстройствами или физическими недостатками, вызванными злоупотреблением алкоголя и наркотиков",
      "MEDICAL_HEALTH_CARE_SERVICES": "Медико-санитарное обслуживание",
      "PRODUCTION_OF_PAINT_SUBSTANCES_AND_PIGMENTS": "Производство красок и пигментов",
      "SELLING_FLOUR": "Продажа муки",
      "COSMETOLOGY_CENTER": "Косметологический центр",
      "BROADCASTING_ACTIVITY": "Вещательная деятельность",
      "CONSTRUCTION_OF_BUILDINGS": "Строительство жилых и нежилых зданий",
      "AESTHETIC_MEDICINE_CENTER": "Центр эстетической медицины",
      "CHESS_TRAINING": "Обучение игре в шахматы",
      "MUSEUM": "Музей",
      "SELLING_BOTTLED_DRINKING_WATER": "Продажа бутилированной питьевой воды",
      "LOMBARD": "Ломбард",
      "PRODUCTION_OF_PAINTS_VARNISHES_PRINTING_INKS_AND_MASTICS": "Производство красок, лаков и подобных покрытий, печатных красок и мастик",
      "INSTALL_ALARM_SYSTEMS_LIGHTNING_RODS_LIGHTING_ANTENNAS": "Услуги по установке систем охранной сигнализации, громоотводов, осветительных систем, антенн",
      "ART_WORKSHOP": "Художественная мастерская",
      "CAR_SHOWROOM": "Автомобильный шоурум",
      "SHAWARMA": "Шаурма",
      "NIGHT_ENTERTAINMENT_CLUB": "Ночной развлекательный клуб",
      "BUSINESS_AND_MANAGEMENT_CONSULTING_SERVICES": "Услуги по консультированию в области коммерческой деятельности и управления",
      "LABORATORY": "Лаборатория",
      "FLORICULTURE_SEED_PRODUCTION": "Цветоводство, производство семян",
      "PRODUCTION_OF_CONCRETE": "Производство бетона",
      "PRODUCTION_OF_SEWING_THREADS": "Производство швейных нитей",
      "CEMENT_SELLING": "Продажа цемента",
      "LAUNDRY": "Прачечная",
      "CAR_PARKING": "Автостоянка",
      "WHOLESALE_AGENCY_SERVICES": "Оптовые агентские услуги",
      "LAHMACUN_TURKISH_PIZZA": "Лахмаджун (турецкая пицца)",
      "FREIGHT_TRANSPORTATION_OFFICE": "Офис грузоперевозок",
      "FABRICATION_OF_DENTAL_PROSTHESES": "Изготовление зубных протезов",
      "PRODUCTION_OF_BEE_PRODUCTS": "Производство продуктов пчеловодства",
      "SERVICES_RELATED_TO_PRINTING_WORKS": "Услуги, связанные с выполнением печатных работ",
      "RENTAL_HOUSING": "Аренда жилья",
      "SELLING_MACHINE_TOOLS": "Продажа станков",
      "RECEPTION_POINT_FOR_METALS_AND_OTHER_WASTE": "Пункт приема металлов и других отходов",
      "POTTERY_PRODUCTION": "Гончарное производство",
      "PRODUCTION_OF_SOAPS_DETERGENTS_AND_CLEANING_AGENTS": "Производство мыла, моющих и чистящих средств",
      "PRODUCTION_OF_WOODEN_CRATES_BOXES": "Производство деревянных ящиков (коробок)",
      "WEDDING_DRESS_RENTAL": "Прокат свадебных платьев",
      "CAR_OIL_CHANGE_SERVICE": "Сервис замены масла",
      "PRODUCTION_OF_REFRIGERATORS_AND_VENTILATION_EQUIPMENT": "Производство холодильников и вентиляционного оборудования",
      "GROWING_FRUIT_TREE_AND_VEGETABLE_SEEDLINGS": "Выращивание саженцев плодовых деревьев и рассады овощей",
      "CONSULTATION_AND_DIAGNOSTIC_CENTER": "Консультативно-диагностический центр",
      "ANIMAL_TRAINING_AND_CARE_SERVICES": "Услуги по дрессировке и уходу за животными",
      "KARAOKE_CLUB": "Караоке-клуб",
      "CAR_WASH_SERVICE": "Автомойка",
      "SELLING_AUDIO_AND_VIDEO_RECORDINGS": "Продажа аудио и видеозаписей",
      "PRODUCTION_OF_WIRE_PRODUCTS": "Производство проволочных изделий",
      "COMPUTER_REPAIR": "Ремонт компьютеров",
      "COURIER_OR_DELIVERY_SERVICE": "Курьер или служба доставки",
      "DRYWALL_SELLING": "Продажа гипсокартона",
      "POTATO_CULTIVATION": "Выращивание картофеля",
      "PRODUCTION_OF_LOCKS_AND_HINGES": "Производство замков и петель",
      "FURNITURE_SHOWROOM": "Мебельный салон",
      "BOILER_REPAIR": "Ремонт котлов",
      "JEWELRY_WORKSHOP": "Ювелирная мастерская",
      "PRODUCTION_OF_FISH_PRODUCTS": "Производство рыбной продукции",
      "CONSTRUCTION_MATERIALS_MARKET": "Рынок строительных материалов",
      "SELLING_COFFEE_TEA_COCOA_AND_SPICES": "Продажа кофе, чая, какао и специй",
      "MANUFACTURE_OF_SAWN_TIMBER": "Производство пиломатериалов",
      "SELLING_SAND_AND_GRAVEL": "Продажа песка и гравия",
      "IRON_GATES_PRODUCTION": "Производство железных ворот",
      "CULTIVATION_OF_OTHER_FRUITS": "Выращивание прочих фруктов",
      "BASIC_TECHNOLOGICAL_PROCESSES_OF_MECHANICAL_ENGINEERING": "Основные технологические процессы машиностроения",
      "CUSTOMS_SERVICES": "Таможенные услуги",
      "SUSHI": "Суши",
      "INSTALLATION_OF_ELECTRICAL_NETWORKS_AND_EQUIPMENT": "Услуги по монтажу электрических сетей и оборудования",
      "ACTIVITIES_IN_THE_FIELD_OF_ARCHITECTURE": "Деятельность в области архитектуры",
      "PACKAGING_SERVICES": "Услуги упаковки",
      "LOCAL_SELF_GOVERNANCE_ACTIVITIES": "Деятельность органов местного самоуправления",
      "CAR_RENTAL_SERVICES": "Услуги аренды автомобилей",
      "OTHER_EDUCATIONAL_SERVICES": "Прочие услуги в сфере образования",
      "CHILDREN_HAIRDRESSING": "Детская стрижка",
      "GLASS_PRODUCTION": "Производство стекла",
      "STONE_PRODUCTION": "Производство камня",
      "METAL_CASTING_AND_PRODUCTION_OF_VARIOUS_EQUIPMENT": "Литье металлов и производство различного оборудования",
      "PRODUCTION_OF_VARIOUS_CLOTHING": "Производство различной одежды",
      "PRODUCTION_OF_CAST_IRON_STEEL_AND_FERROALLOYS": "Производство чугуна, стали и ферросплавов",
      "HOSTEL": "Хостел",
      "LAW_CONSULTING_OFFICE": "Юридическая консультация",
      "PSYCHOLOGICAL_CENTER": "Центр психологической помощи",
      "TELECOMMUNICATION_ACTIVITIES": "Телекоммуникационная деятельность",
      "GIFT_DECORATING_AND_WRAPPING_SERVICES": "Услуги по оформлению и упаковке подарков",
      "WATER_PRODUCTION": "Производство воды",
      "PRODUCTION_OF_FRUIT_AND_VEGETABLE_JUICES": "Производство фруктовых и овощных соков",
      "ATTRACTIONS_AND_WATER_PARKS": "Аттракционы и аквапарки",
      "FOOTBALL_SCHOOL": "Футбольная школа",
      "SPICE_PRODUCTION": "Производство специй",
      "GUEST_HOUSE": "Гостевой дом",
      "TOMATO_PRODUCTION": "Производство томатов",
      "STONE_QUARRY": "Каменный карьер",
      "RENTAL_OF_SPORTS_AND_LEISURE_GOODS": "Прокат товаров для спорта и отдыха",
      "WEDDING_PHOTO_STUDIO": "Студия свадебной фотосъемки",
      "ADHESIVE_PRODUCTION": "Производство клея",
      "SAND_AND_GRAVEL_QUARRY": "Песчано-гравийный карьер",
      "SELLING_SPARE_PARTS": "Продажа запчастей",
      "SELLING_MEN_CLOTHING": "Продажа мужской одежды",
      "PHOTO_STUDIO": "Фотостудия",
      "PRODUCTION_OF_METAL_PIPES": "Производство металлических труб",
      "PRODUCTION_OF_TANKS_BUCKETS_AND_CONTAINERS": "Производство баков, ведер и контейнеров",
      "TAX_SERVICE": "Налоговая служба",
      "BLACKSMITH": "Кузнец",
      "ZOO": "Зоопарк",
      "PRODUCTION_OF_LAVASH_BREAD": "Производство лаваша",
      "GROCERY_MARKET": "Продуктовый рынок",
      "QUTAB_HOUSE_FLATBREAD": "Кутабхана (тонкая лепешка)",
      "MANUFACTURE_OF_CLOTHING_FOR_INDUSTRIAL_FACILITIES": "Изготовление одежды для промышленных объектов",
      "RENTAL_OF_OTHER_CLOTHES": "Прокат прочей одежды",
      "PRODUCTION_OF_PLASTIC_SHEETS_STRIPS_PIPES_AND_PROFILES": "Производство пластиковых листов, полос, труб и профилей",
      "COMPUTER_SERVICES": "Компьютерные услуги",
      "AUDIT_SERVICES": "Аудиторские услуги",
      "SELLING_COCKTAILS": "Продажа коктейлей",
      "REALTOR_SERVICES": "Риэлторские услуги",
      "MANUFACTURE_OF_OTHER_RUBBER_PRODUCTS": "Изготовление прочих изделий из резины",
      "PRODUCTION_OF_BRICKS_TILES_FIRED_CLAY_BUILDING_MATERIALS": "Производство кирпичей, плитки и других строительных материалов из обожженной глины",
      "GLASS_WASTE_COLLECTION_POINT": "Пункт приема стеклотары",
      "PREPARATORY_COURSES_FOR_UNIVERSITY_ENTRANTS_ABITURIENTS": "Подготовительные курсы для абитуриентов",
      "PRODUCTION_OF_STYROFOAM_EXPANDED_POLYSTYRENE": "Производство пенопласта (экспандированного полистирола)",
      "PRODUCTION_OF_CABLES": "Производство кабелей",
      "PILATES_CENTER": "Центр пилатеса",
      "COMPUTER_COURSES": "Компьютерные курсы",
      "PRODUCTION_OF_PASTA_NOODLES_AND_SIMILAR_PRODUCTS": "Производство макаронных изделий",
      "PATIENT_CARE": "Уход за пациентами",
      "PRODUCTION_OF_CONFECTIONERY_PRODUCTS": "Производство кондитерских изделий",
      "INTERNET_PROVIDER_SERVICES": "Услуги интернет-провайдера",
      "SPORTS_AND_FITNESS_CENTER": "Спортивно-оздоровительный центр",
      "TOPAZ_AREA_REGION": "Топазный район (регион)",
      "CAR_DIAGNOSTICS": "Диагностика автомобилей",
      "INTERNET_CLUB": "Интернет-клуб",
      "POST_OFFICE": "Почтовое отделение или филиал",
      "SHOE_REPAIR": "Ремонт обуви",
      "CULTIVATION_OF_SPICES_PERFUME_PLANTS_AND_MEDICINAL_HERBS": "Выращивание пряностей, парфюмерных растений и лекарственных трав",
      "TRANSLATION_AGENCY": "Бюро переводов",
      "PHOTO_PRINTING_SHOP": "Салон фотопечати",
      "DECORATION_OF_TRAYS": "Украшение подносов",
      "BATTERY_PRODUCTION": "Производство аккумуляторов",
      "PRODUCTION_OF_FRUIT_AND_VEGETABLE_SNACKS": "Производство фруктовых и овощных закусок",
      "CANDY_STORE": "Магазин конфет",
      "PIE_SHOP": "Пирожковая",
      "CAR_TUNING": "Авто тюнинг",
      "CHILD_DEVELOPMENT_CENTRE": "Детский развивающий центр",
      "SANATORIUM": "Санаторий",
      "ACCOMMODATION_SERVICES": "Услуги по обеспечению проживания",
      "LOGOPEDIST_SERVICES": "Услуги логопеда",
      "SHEEP_AND_GOATS_BREEDING": "Разведение овец и коз",
      "COMPUTER_HALL": "Компьютерный зал",
      "REPAIR_AND_PRODUCTION_OF_AGRICULTURAL_AND_FORESTRY_TRACTORS": "Ремонт и производство сельскохозяйственных и лесных тракторов",
      "EYEGLASSES_REPAIR": "Ремонт очков",
      "STONE_MARKET": "Рынок камней",
      "PRODUCTION_OF_WOMEN_CLOTHING": "Производство женской одежды",
      "PRODUCTION_OF_OILS_AND_FATS": "Производство масел и жиров",
      "SPEECH_DEVELOPMENT_CENTER": "Центр развития речи",
      "BLINDS_PRODUCTION": "Производство жалюзи",
      "TOURIST_CAMPS": "Туристические лагеря",
      "TURNING_WORK": "Токарные работы",
      "PRODUCTION_OF_CHILDREN_CLOTHING": "Производство детской одежды",
      "COVER_REPAIR": "Ремонт чехлов",
      "PRODUCTION_OF_TOMBSTONES": "Производство надгробий",
      "ART_GALLERY": "Художественная галерея",
      "DESIGN_COURSES": "Курсы по дизайну",
      "PRODUCTION_OF_WINES_AND_WINE_MATERIALS": "Производство вин и виноматериалов",
      "CURRENCY_EXCHANGE_OFFICE": "Пункт обмена валюты",
      "VIDEO_COPYING_SERVICE": "Копирование видеозаписей",
      "BREWING": "Пивоварение",
      "WASTE_TREATMENT_AND_DISPOSAL": "Обработка и утилизация отходов",
      "PRODUCTION_OF_NAPKINS": "Производство салфеток",
      "REPAIR_OF_METAL_PRODUCTS": "Ремонт металлических изделий",
      "PRODUCTION_OF_SEALS_AND_STAMPS": "Изготовление печатей и штампов",
      "SELLING_NON_ALCOHOLIC_BEVERAGES": "Продажа безалкогольных напитков",
      "EDUCATION_SERVICES": "Образовательные услуги",
      "DESIGN_WORK": "Дизайнерская деятельность",
      "PRODUCTION_OF_MOLDED_DECOR": "Производство лепного декора",
      "PRODUCTION_OF_STATIONERY_SUPPLIES": "Производство канцелярских товаров",
      "DORMITORY_SERVICES": "Услуги общежития",
      "WOMEN_COUNSELLING_CENTER": "Женская консультация",
      "PRODUCTION_OF_AUTOMOTIVE_PAINTS": "Производство автомобильных красок",
      "BICYCLE_REPAIR": "Ремонт велосипедов",
      "CHEESE_AND_CURD_PRODUCTION": "Производство сыров и творога",
      "SELLING_COMPUTERS_PERIPHERAL_DEVICES_AND_SOFTWARE": "Продажа компьютеров, периферийных устройств и программного обеспечения",
      "TEXTILE_PRODUCTION": "Текстильное производство",
      "PRODUCTION_OF_HOSIERY": "Производство чулочно-носочных изделий",
      "SELLING_BABY_FOOD": "Продажа детского питания",
      "LIBRARY": "Библиотека",
      "CLEANING_SERVICE": "Клининговые услуги",
      "PRODUCTION_OF_CLOTHING_ACCESSORIES": "Производство аксессуаров к одежде",
      "VOCATIONAL_TRAINING_COURSES": "Курсы профессиональной подготовки",
      "ADVISORY_SERVICES_FOR_AGRONOMISTS_AND_OTHER": "Консультационные услуги для агрономов, экономистов сельского хозяйства и фермеров",
      "BILLIARD_ROOM": "Бильярдный зал",
      "SELLING_GOLD": "Продажа золота",
      "MASSAGE_SALON": "Салон массажа",
      "SERVICES_FOR_PLANNING_EFFICIENCY_CONTROL": "Услуги по планированию, организации, обеспечению эффективности и контроля, предоставление информации для руководства и других коммерческих организаций и государственных служб",
      "SELLING_EGGS": "Продажа яиц",
      "CLEANING_OF_BUILDINGS": "Уборка зданий",
      "SHOOTING_CENTER": "Стрелковый центр",
      "PAINTING_OF_METAL_PRODUCTS": "Покраска металлических изделий",
      "PASSENGER_TRANSPORTATION_OFFICE": "Управление пассажирским транспортом",
      "PRODUCTION_OF_WOODEN_DOORS_AND_WINDOWS": "Производство деревянных дверей и окон",
      "SWIMMING_COMPLEX": "Плавательный комплекс",
      "WELDER": "Сварщик",
      "PRODUCTION_OF_STRONG_DRINKS": "Производство крепких спиртных напитков, ликеро-водочных изделий и материалов для их производства",
      "LABOUR_SUPPLY_ACTIVITIES": "Деятельность по обеспечению трудовыми ресурсами",
      "ALUMINIUM_PRODUCTION": "Производство алюминия",
      "COFFEE_PRODUCTION": "Производство кофе",
      "KEY_MAKING_AND_REPAIR": "Изготовление и ремонт ключей",
      "FIREWOOD_PRODUCTION": "Производство дров",
      "PRE_SCHOOL_TRAINING": "Занятия по подготовке к школе",
      "GAS_PRODUCTION": "Производство газа",
      "GARAGE": "Гараж",
      "CATTLE_MARKET": "Рынок крупного рогатого скота",
      "REPAIR_OF_MACHINES_AND_EQUIPMENT": "Ремонт машин и оборудования",
      "EMPLOYMENT_CENTER": "Центр занятости",
      "CARING_FOR_ELDERLY_AND_DISABLED_PEOPLE": "Уход за пожилыми людьми и инвалидами",
      "LOTTERY_GAMES": "Лотерейные игры",
      "RENTAL_OF_VIDEO_TAPES_AND_DISCS": "Прокат видеокассет и дисков",
      "ACCOUNTING_SERVICES": "Бухгалтерские услуги",
      "PRODUCTION_OF_ELECTRIC_LAMPS_AND_LIGHTING_EQUIPMENT": "Производство электрических ламп и осветительного оборудования",
      "WALLPAPER_PRODUCTION": "Производство обоев",
      "AIRPORT_OPERATIONS": "Деятельность аэропортов",
      "MANAGEMENT_OF_APARTMENT_BUILDINGS": "Управление многоквартирными домами",
      "TOURIST_BASES": "Туристические базы",
      "INDUSTRIAL_GOODS_MARKET": "Рынок промышленных товаров",
      "PRODUCTION_OF_MUSICAL_INSTRUMENTS": "Производство музыкальных инструментов",
      "MANUFACTURE_OF_OTHER_WOODEN_PRODUCTS": "Изготовление прочих деревянных изделий",
      "FOREIGN_LANGUAGE_COURSES": "Курсы иностранных языков",
      "BICYCLE_PRODUCTION": "Производство велосипедов",
      "CONSTRUCTION_OF_RESIDENTIAL_BUILDINGS": "Строительство жилых домов",
      "CLOTHING_REPAIR": "Ремонт одежды",
      "PRODUCTION_OF_LEMONADE": "Производство лимонада",
      "DANCE_STUDIO": "Танцевальная студия",
      "FAIR": "Ярмарка",
      "INSTALLATION_SERVICES_OF_FIRE_ALARM_SYSTEMS": "Услуги по установке систем пожарной сигнализации",
      "RESORT_AREA": "Курортная зона",
      "SELLING_GAS_PRODUCTS": "Продажа газовой продукции",
      "SELLING_LIFTING_EQUIPMENT": "Продажа грузоподъемной техники",
      "PRODUCTION_OF_GATES": "Производство ворот",
      "FISH_FARMING": "Рыбоводство",
      "SAUNA": "Сауна",
      "PRODUCTION_OF_ESSENTIAL_OILS": "Производство эфирных масел",
      "TILE_PRODUCTION": "Производство плитки",
      "CONSULTING_SERVICES_IN_PUBLIC_RELATIONS_AND_INFORMATION": "Консалтинговые услуги в области связей с общественностью и обмена информацией",
      "TOYS_PRODUCTION": "Производство игрушек",
      "CAR_DRY_CLEANING": "Химчистка автомобилей",
      "REPAIR_OF_HOUSEHOLD_APPLIANCES": "Ремонт бытовой техники",
      "PRODUCTION_OF_CHOCOLATE": "Производство шоколада",
      "TOILET": "Туалет",
      "PRODUCTION_OF_PAPER_BAGS": "Производство бумажных пакетов",
      "WEAVING": "Ткачество",
      "PRODUCTION_OF_TOBACCO_PRODUCTS": "Производство табачных изделий",
      "CARPET_CLEANING": "Чистка ковров",
      "SELLING_CHOCOLATE": "Продажа шоколада",
      "PROVISION_OF_SERVICES_TO_THE_MINING_INDUSTRY": "Оказание услуг в горнодобывающей отрасли",
      "CAR_PRODUCTION": "Производство автомобилей",
      "WEDDING_CAR_DECORATION": "Оформление свадебных автомобилей",
      "PEAT_EXTRACTION": "Добыча торфа",
      "PROVISION_OF_OTHER_SOCIAL_SERVICES_WITHOUT_HOUSING": "Предоставление прочих социальных услуг без обеспечения жильем, не входящих в другие группы",
      "MANUFACTURE_OF_CARPETS_AND_CARPETING_PRODUCTS": "Производство ковров и ковровых изделий",
      "ACTIVITIES_OF_INFORMATION_AGENCIES": "Деятельность информационных агентств",
      "TURNER": "Токарь",
      "PUBLISHERS": "Издательство",
      "MUSIC_LESSONS": "Уроки музыки",
      "TEA_LEAF_CULTIVATION": "Выращивание чайного листа",
      "MANUFACTURE_OF_LEATHER_AND_LEATHER_GOODS": "Производство кожи и изделий из нее",
      "STATE_ADMINISTRATIVE_BUILDING": "Государственное административное здание",
      "RESEARCH_SERVICES_IN_NATURAL_AND_TECHNICAL_SCIENCES": "Прочие исследовательские услуги в области естественных и технических наук",
      "PRODUCTION_OF_PERFUMES_AND_COSMETICS": "Производство парфюмерии и косметики",
      "PRODUCTION_OF_ELECTRONIC_COMPONENTS": "Производство электронных компонентов",
      "MEAT_MARKET": "Мясной рынок",
      "FERTILISER_PRODUCTION": "Производство удобрений",
      "PAINTING_COURSE": "Курс живописи",
      "SKI_SLOPES_OPERATIONS": "Эксплуатация горнолыжных трасс",
      "EXPLOITATION_OF_DANCE_FLOORS": "Эксплуатация танцевальных площадок",
      "SELLING_FUR_AND_LEATHER_GOODS": "Продажа меховых и кожаных изделий",
      "ACADEMY": "Академия",
      "SELLING_CONFECTIONERY": "Продажа кондитерских изделий",
      "CHILDREN_PHOTO_STUDIO": "Детская фотостудия",
      "PRODUCTION_OF_SUNFLOWER_SEEDS": "Производство семян подсолнечника",
      "PUMP_REPAIR": "Ремонт насосов",
      "ACCOUNTING_COURSES": "Курс бухгалтерского учета",
      "PRODUCTION_OF_PETROLEUM_PRODUCTS": "Производство нефтепродуктов",
      "BREEDING_OF_OTHER_ANIMALS": "Разведение прочих животных",
      "SCHOOL": "Школа",
      "PRODUCTION_OF_ELECTRIC_MOTORS_GENERATORS_TRANSFORMERS": "Производство электрических двигателей, генераторов и трансформаторов",
      "PRODUCTION_OF_LEGUME_CROPS": "Производство бобовых культур",
      "PRODUCTION_OF_DIETARY_FOODS": "Производство диетических продуктов питания",
      "TIN_WORKER": "Слесарь по металлу",
      "RESTORATION_OF_FINE_ART_WORKS": "Восстановление произведений изобразительного искусства",
      "CAMPING": "Кемпинг",
      "THEATER": "Театр",
      "MANUFACTURE_OF_KNIFE_PRODUCTS": "Производство ножевых изделий",
      "GOAT_BREEDING": "Разведение коз",
      "HAIR_TRANSPLANTATION_CENTER": "Центр пересадки волос",
      "REPAIR_AND_MAINTENANCE_OF_VESSELS": "Ремонт и техническое обслуживание судов",
      "SELLING_MUSICAL_INSTRUMENTS": "Продажа музыкальных инструментов",
      "POST_PRODUCTION_EDITING_FILMS_VIDEO_AND_TV_PROGRAMS": "Постпродакшн (монтаж) кинофильмов, видео и телепрограмм",
      "CLINIC_HOSPITAL": "Больница",
      "HOSPITAL": "Госпиталь",
      "COPPERWORKING": "Обработка меди",
      "CONSULTING_SERVICES_IN_VARIOUS_AREAS": "Консультационные услуги в различных областях",
      "ORGANIZATION_OF_CONGRESSES_AND_PROFESSIONAL_EXHIBITIONS": "Организация конгрессов и профессиональных выставок",
      "PREPARATION_OF_CERAMIC_PRODUCTS": "Подготовка керамических изделий",
      "PRODUCTION_OF_CERAMIC_PRODUCTS": "Производство керамических изделий",
      "BUSINESS_AND_MANAGEMENT_SERVICES": "Услуги в области коммерческой деятельности и управления"
    },
    "storeActivityLevelsOfDetail": {
      "general": "Общий",
      "main": "Высокий",
      "middle": "Средний",
      "lower": "Низкий"
    },
    "storeActivityByLevelsOfDetail": "Вид деятельности по уровням детализации"
  },
  "user": {
    "accessRights": "Права доступа",
    "deactivationDate": "Дата деактивации",
    "email": "Адрес электронной почты",
    "firstName": "Имя",
    "lastName": "Фамилия",
    "middleName": "Отчество",
    "mobilePhone": "Мобильный номер",
    "password": "Пароль",
    "phone": "Номер телефона",
    "roles": "Роли",
    "roleTypes": {
      "CENTRAL_INSPECTOR": "Центральный инспектор",
      "DIRECTOR": "Директор",
      "EXPERT": "Эксперт",
      "AUDITOR": "Ревизор",
      "INSPECTOR": "Инспектор",
      "OPERATOR": "Оператор",
      "TAXPAYER": "Налогоплательщик",
      "REGIONAL_INSPECTOR": "Региональный инспектор",
      "ADMIN": "Администратор"
    },
    "userName": "Имя",
    "userRoles": "Роли пользователя",
    "userStatus": "Статус пользователя",
    "userStatuses": {
      "ACTIVE": "Активный",
      "DELETED": "Удален",
      "INACTIVE": "Неактивный"
    },
    "verificationCode": "Проверочный код",
    "additionalUserRoles": "Дополнительные роли",
    "userRole": "Роль пользователя"
  },
  "inspection": {
    "productName": "Наименование приобретенного товара",
    "inspectionResult": "Результат проверки",
    "completionDate": "Дата завершения проверки",
    "resultComment": "Комментарий ревизора к результату проверки",
    "errors": {
      "createInspectionError": "Не удалось назначить проверку",
      "notClosedInspectionAlreadyExists": "Назначить новую проверку нельзя, пока не закрыта существующая",
      "cancelInspectionError": "Не удалось отменить проверку",
      "assignInspectionError": "Не удалось пометить проверку как взятую в работу",
      "emptyResult": "Выберите результат проверки",
      "completeInspectionError": "Не удалось завершить проверку",
      "inspectionDateError": "Дата и время проведения проверки не может быть больше текущего времени",
      "productNameError": "Наименование приобретенного товара не может быть пустой строкой и должно быть до {{maxLength}} символов"
    },
    "inspectionsHistory": "История проверок объекта",
    "createInspection": "Назначить проверку",
    "assignInspection": "Взять в работу",
    "completeInspection": "Завершить проверку",
    "cancelInspection": "Отменить проверку",
    "inspectionInitiatorComment": "Комментарий инициатора проверки",
    "confirmCancelInspection": "Вы действительно хотите отменить проверку?",
    "confirmAssignInspection": "Вы действительно хотите взять данную проверку в работу?",
    "assignedDate": "Взята в работу",
    "initiator": "Инициатор",
    "inspectionStatuses": {
      "OPEN": "Открыта",
      "IN_PROGRESS": "В работе",
      "CLOSED": "Закрыта"
    },
    "inspectionResults": {
      "RECEIPT_OK": "Чек предоставлен",
      "NO_RECEIPT": "Чек не предоставлен",
      "STORE_CLOSED": "Объект закрыт",
      "STORE_NOT_FOUND": "Объект не найден",
      "CASHBOX_NOT_FOUND": "Отсутствует касса"
    },
    "inspectionDate": "Дата проведения проверки",
    "inspectionPeriod": "Период проверки",
    "inspectionStatus": "Статус проверки"
  },
  "downloadings": {
    "delayedDownloadings": "Отложенные загрузки",
    "errors": {
      "failedToGetDelayedDownloadings": "Не удалось получить список отложенных загрузок",
      "failedToPollDelayedDownloadings": "Не удалось обновить список отложенных загрузок",
      "requestToCreateFileFailed": "Запрос на создание файла не выполнен. Пожалуйста, проверьте ограничения по отложенным загрузкам"
    },
    "downloadingTypes": {
      "OPERATORS": "Операторы",
      "COMPANIES": "Налогоплательщики",
      "STORES": "Объекты",
      "CASHBOXES": "Кассы",
      "DOCUMENTS": "Кассовые чеки",
      "DEVICES": "Токены",
      "REPORT_CASH_BOX_DAY": "Отчет по дням",
      "REPORT_CASH_BOX": "Отчет по кассам"
    },
    "downloadingStatuses": {
      "CREATED": "Запрос принят",
      "IN_PROGRESS": "Формируется",
      "READY": "Подготовлен",
      "ERROR": "Ошибка"
    },
    "downloadingErrors": {
      "MAX_ROWS_COUNT": "Ошибка формата excel файла. Превышен лимит количества строк"
    },
    "downloadingRequestedDate": "Дата запроса",
    "limitationsHintDays": "Время хранения подготовленных к загрузке файлов {{limit}} дней",
    "limitationsHintItems": "Максимальное количество файлов - {{limit}}",
    "fileCreationRequestAccepted": "Запрос на создание файла принят. Пожалуйста, смотрите список отложенных загрузок"
  },
  "ServiceScreen": {
    "hints": {
      "onlinePhisicalFDVersion": "Операция доступна для физических касс в режиме онлайн, версия фискального драйвера {{param}} или выше",
      "onlinePhisicalOrSoftwareFDVersion": "Операция доступна для физических или программных касс в режиме онлайн, версия фискального драйвера {{param}} или выше",
      "addCashboxesForOperation": "Добавить кассы для выполнения операции",
      "addCashboxes": "Пожалуйста, добавьте кассы",
      "limitForNumberOfCashboxes": "Вы можете добавить до {{limit}} касс",
      "limitForOneCashbox": "Вы можете добавить только одну кассу",
      "showOperationData": "Показать данные операции",
      "selectTargetVersion": "Выберите целевую версию",
      "deleteAllCashboxes": "Удалить все кассы",
      "deleteCashbox": "Удалить кассу",
      "operationSuccessful": "Операция успешно выполнена",
      "performOperationConfirmation": "Вы действительно хотите выполнить операцию \"{{operationType}}\" для выбранного списка токенов?",
      "deviceAlreadyInList": "Данный токен уже добавлен в список",
      "deleteAllDevices": "Удалить все токены",
      "addDevices": "Добавьте токены для выполнения операции",
      "minFwVertionForOperation": "Версия прошивки {{param}} или выше",
      "limitForNumberOfDevices": "Вы можете добавить до {{limit}} токенов",
      "selectAllCashboxesForOperation": "Выбрать все кассы для выполнения операции",
      "selectCashboxForOperation": "Выбрать кассу для выполнения операции"
    },
    "errors": {
      "failedToCreateCashboxesTasks": "Не удалось запросить выполнение операции для списка касс",
      "failedToGetCashboxesTasksStatuses": "Не удалось получить статус выполнения операции для списка касс",
      "failedToLoadFactoryNumbersList": "Не удалось загрузить список допустимых заводских номеров"
    },
    "dropZoneText": "Перетяните .json или .csv файл сюда или нажмите, чтобы выбрать",
    "initialisationOperationsTypes": {
      "PRODUCE": "Produce",
      "RESERVE": "Reserve",
      "UNRESERVE": "Unreserve",
      "USB_TYPE": "Usb type"
    },
    "serviceOperationTypes": {
      "BREAK": "Break",
      "UNBREAK": "Unbreak",
      "LOSE": "Lose",
      "LOSE_ROLLBACK": "Unlose",
      "SUPPORT": "To service",
      "SUPPORT_ROLLBACK": "Unsupport",
      "DELETE": "Delete"
    },
    "addDeviceToList": "Добавить токен в список",
    "serviceOperations": "Прочие сервис операции",
    "deviceInitialization": "Инициализация токена",
    "enterPinCode": "Пожалуйста, введите PIN код",
    "pinCode": "PIN код",
    "dumpOperationTitle": "Дамп данных с токена",
    "saveDump": "Сохранить дамп",
    "allowWithDocumentUnsent": "Разрешить с неотправленным чеком",
    "allowWithShiftOpened": "Разрешить без закрытия смены",
    "repairOperationTitle": "Восстановление токена",
    "repairDevice": "Восстановить токен",
    "newAdminPinCode": "Новый PIN код администратора",
    "newAdminPukCode": "Новый PUK код администратора",
    "newUserPinCode": "Новый PIN код пользователя",
    "newUserPukCode": "Новый PUK код пользователя",
    "adminPinCode": "PIN код администратора"
  }
}
